import React, { Component } from "react";
import Header from "../../../Common/Component/Header";
import Sidebar from "../../../Common/Component/Sidebar";
import ReportSidebar from "../../Common/ReportSidebar";
import BatchUpdateSelectedCustomers from "./BatchUpdateSelectedCustomers";
import Loader from "../../../Common/Component/Loader";
import moment from 'moment';
import DataTable from './Datatable';
import { Select, Drawer ,Checkbox} from 'antd';
import {errorHandle} from "../../../Common/errorHandle";
import _ from 'lodash';
import { CSVLink } from "react-csv";
import '../css/invoice-reconciliation-reports.css';
import { Base64 } from 'js-base64';

import smile_icon from "../../../../Assets/images/smile.png";
import neutral_icon from "../../../../Assets/images/confused.png";
import sad_icon from "../../../../Assets/images/sad.png";
import { AlertTriangle } from 'react-feather';

import { Table } from "antd";
import { formatToCurrency } from "../../../../Tools/formatToCurrency";

const { Option } = Select;

class ReportList extends Component {
  state = {
    loader: false,
    title: "",
    id:'',
    customerList: [],
    customerReport: [],
    customer_statement_report_pagination: {
      current: 1,
      showSizeChanger: false,
      pageSize: 15
    },
    franchiseList:[],
    dailyReports:[],
    daily_log_report_pagination: {
      current: 1,
      showSizeChanger: false,
      pageSize: 15
    },
    active_pagination: '15',
    franchiseFilters: {},
    reportdetails: false,
    revenueReportDetails: {
      zipcodeList: [],
      typeList: [],
      revenueReport: []
    },
    revenue_report_pagination: {
      current: 1,
      showSizeChanger: false,
      pageSize: 15
    },
    customerComplaintsReport: [],
    invoiceReconciliationReport:[],
    customerComplaintsTickets: [],
    customer_complaints_report_pagination: {
      current: 1,
      showSizeChanger: false,
      pageSize: 15
    },
    customerId: '',
    selectedRowKeys: [],
    commercialReports: [],
    commercialReportDetails: [],
    commercial_sales_report_pagination: {
      current: 1,
      showSizeChanger: false,
      pageSize: 15
    },
    userRoles: [],
    franchise: [],
    customerPriceIncreaseReport: [],
    customer_price_increase_report_pagination: {
      current: 1,
      showSizeChanger: false,
      pageSize: 15,
      position: ['bottomCenter']
    },
    royaltyReport: [],
    royalty_report_ordering: 'name',
    filters: {
      field_office_uuids: [],
      end_date: moment().endOf('month').format('YYYY-MM-DD'),
      start_date: moment().startOf('month').format('YYYY-MM-DD')
    },
    royalty_report_pagination: {
      current: 1,
      showSizeChanger: false,
      pageSize: 15
    },
    selectedRowKeysUpdate: [],
    is_Batch_Update_Selected_Customers: false,
    commercial_sales_report_ordering : 'name',
    search_value: '',
    invoice_search_array:['product','service','discount','tax'],
    headers : [
      { label: "Franchise", key: "franchise" },
      { label: "Time Period", key: "timeperiod" },
      { label: "Total Jobs Completed ($)", key: "totaljobscompleted" },
      { label: "Total Completed & Invoiced ($)", key: "totalinvoiced" },
      { label: "Jobs Completed but not Invoiced ($)",key:"totaljobscompletednotinvoiced"}     
    ],
    data : [],
    Fid:null,
    cancellation_report_pagination: {
      current: 1,
      showSizeChanger: false,
      pageSize: 15
    },
    cancellationReport: [],
    summaryReports:[],
    stage: '',

    // Lead and Signup Reports
    customer_type: '',
    residentialLeadReport: [],
    residentialSignupReport: [],
    lead_signup_report_ordering: '',
    lead_signup_report_pagination: {
      current: 1,
      pageSize: 15,
      showSizeChanger: false,
    },
    show_warning: false,

    // Coupon Report
    couponReport: [],
    coupon_report_ordering: '',
    coupon_report_pagination: {
      current: 1,
      pageSize: 15,
      showSizeChanger: false,
    },
    commercialProposalReport: [],
    commercialSignupReport: [],
    isShowPaginationFooter :false,
    loaderExport:false,
    previous_selected_customers_count: 0,
    is_select_all_raised_price_increase: false,
  };


  componentDidMount = async () => {
    const { filters } = this.state;
    const {franchise_uuid} = this.getLoggedInUserRole();
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const accessToken = authUser ? authUser.key : "";
    let fo_field_office = [];
    let updatedFilters = {};

    if (accessToken) {
      this.setState({ loader: true });
    }
    else {
      window.location.assign('/');
      localStorage.clear();
      sessionStorage.clear();
    }

    switch(this.props.location.state.query.id)
    {
    case 'customer_statement':
      this.props.getCustomerList()
      return this.setState({ 
        id: 'customer_statement',
        title: "Customer Statement"
      });
    
    case 'daily_log_report':
      this.props.getDailyLogFranchise()
      this.props.getDailyLogReports({
        created_at__date: `${moment().format('YYYY-MM-DD')}`
      })
      return this.setState({ 
        id: 'daily_log_report',
        title: "Daily Log Reports",
        franchiseFilters: {
          created_at__date: `${moment().format('YYYY-MM-DD')}`
        }
      });
      
    case "in_territory_revenue_reports":
      if(franchise_uuid) {
        this.props.getRevenueReportFranchise({field_office_id: franchise_uuid});
      } else {
        this.props.getRevenueReportFranchise()
      }
      this.props.getReportTypeList()
      this.props.getRevenueReport()
      return this.setState({
        id: "in_territory_revenue_reports",
        title: "In Territory Revenue Reports"
      });
      
    case 'customer_complaints_report':
      this.props.getCustomerComplaintsFranchise()
      this.props.getCustomerComplaintsReport({
        user__messages__created_at__date__range: `${moment().subtract(1, 'years').format('YYYY-MM-DD')},${moment().format('YYYY-MM-DD')}`,
        offset: 0,
        limit: 15
      })
      return this.setState({
        id: 'customer_complaints_report',
        title: 'Customer Complaints Report',
        franchiseFilters: {
          user__messages__created_at__date__range: `${moment().subtract(1, 'years').format('YYYY-MM-DD')},${moment().format('YYYY-MM-DD')}`
        }
      })
      
    case 'invoice_revenue_report':
      this.props.getFranchise();
      return this.setState({
        id: 'invoice_revenue_report',
        title: 'Job Completed to Invoiced Reconciliation Report',
      })

    case "commercial_sales_report":
      this.props.getCommercialSalesFranchise();
      this.props.getCommercialSalesReports({
        serviceorder__created_at__date__range: `${moment().subtract(1, 'years').format('YYYY-MM-DD')},${moment().format('YYYY-MM-DD')}`});
      return this.setState({
        id: "commercial_sales_report",
        title: "Commercial Sales Report",
        franchiseFilters: {
          serviceorder__created_at__date__range: `${moment().subtract(1, 'years').format('YYYY-MM-DD')},${moment().format('YYYY-MM-DD')}`
        }
      });

    case "customer_price_increase_report":
      /**
         * AUTHOR: Ritesh Solanki
         * CHANGED: 05-10-2021 2:48 PM (Tuesday)
         * <DOOD-1084>As per this ticket we are going to pass "last_increase__range" and "first_service" query string param on page load</DOOD-1084>
         */
      // this.props.getCustomerPriceIncreaseReport({
      //   last_increase__range: `${moment().subtract(1, 'years').format('YYYY-MM-DD')},${moment().format('YYYY-MM-DD')}`,
      //   first_service: `${moment().subtract(1, 'years').format('YYYY-MM-DD')},${moment().format('YYYY-MM-DD')}`});
      //this.props.getCustomerPriceIncreaseReport();
      this.props.getCustomerPriceIncreaseReportUserRoles();
      this.props.getCustomerPriceIncreaseReportFranchises();
      return this.setState({
        id: "customer_price_increase_report",
        title: "Price Increase Report"
      });

    case "customer-cancelation-report": 
      fo_field_office = authUser.user.field_offices.map(item => item.uuid);
      updatedFilters = filters;

      if(authUser?.user?.user_roles.map(x => x.name).includes("franchise_owner"))
      {
        updatedFilters = {...filters, field_office__uuids: fo_field_office};
        this.setState({filters: updatedFilters});
      }

      this.props.getFranchise({ordering: "field_office__name"});
      this.props.getCancellationSummaryReport();
      return this.setState({
        id: "customer-cancelation-report",
        title: "Cancellation Report",
      });

    case "royalty-report":
      fo_field_office = authUser.user.field_offices.map(item => item.uuid);
      updatedFilters = filters;

      if(authUser?.user?.user_roles.map(x => x.name).includes("franchise_owner"))
      {
        updatedFilters = {...filters, field_office_uuids: fo_field_office};
        this.setState({filters: updatedFilters});
      }
        
      this.props.getFranchise({ordering: "field_office__name"});
        
      this.props.getRoyaltyReport({...updatedFilters});
      return this.setState({
        id: "royalty-report",
        loader: false
      });

    case "lead_signup_report":
      fo_field_office = authUser.user.field_offices.map(item => item.uuid);
      updatedFilters = filters;

      if(authUser?.user?.user_roles.map(x => x.name).includes("franchise_owner"))
      {
        updatedFilters = {...filters, field_office_uuids: fo_field_office};
        this.setState({filters: updatedFilters});
      }

      this.props.getFranchise({ordering: "field_office__name"});
      return this.setState({
        loader: false,
        id: "lead_signup_report",
      });

    case "coupon_report":
      fo_field_office = authUser.user.field_offices.map(item => item.uuid);
      updatedFilters = filters;

      if(authUser?.user?.user_roles.map(x => x.name).includes("franchise_owner"))
      {
        updatedFilters = {...filters, field_office_uuids: fo_field_office};
        this.setState({filters: updatedFilters});
      }

      this.props.getFranchise({ordering: "field_office__name"});

      return this.setState({
        loader: false,
        id: "coupon_report",
      });
    
    case "commercial_proposal_signup_report":
      fo_field_office = authUser.user.field_offices.map(item => item.uuid);
      updatedFilters = filters;

      if(authUser?.user?.user_roles.map(x => x.name).includes("franchise_owner"))
      {
        updatedFilters = {...filters, field_office_uuids: fo_field_office};
        this.setState({filters: updatedFilters});
      }

      this.props.getFranchise({ordering: "field_office__name"});

      return this.setState({
        id: "commercial_proposal_signup_report",
        loader: false
      });
      
    default:
      return this.props.history.push(`/reports`);
    }
  } 

  componentDidUpdate = () => {
    if(this.state.show_warning)
    {
      setTimeout(() => this.setState({show_warning: false}), 15000);
    }
  }

  UNSAFE_componentWillReceiveProps = (props) => {
    if (Object.keys(props.ReportPdf.data).length > 0 && props.ReportPdf.data !== this.props.ReportPdf.data) {
      const utf8 = Base64.decode(props.ReportPdf.data);
      const unit8 = new Uint8Array(utf8);
      for (var i = 0; i <  unit8.length; i++){
        unit8[i] = utf8.charCodeAt(i);
      } 

      var file = new Blob([unit8], {type: 'application/pdf;base64'});
      var fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      this.setState({loader: false});
    }

    if (Object.keys(props.ReportPdf.errors).length > 0 && 
      props.ReportPdf.errors !== this.props.ReportPdf.errors) {
      // display error messsage
      this.setState({ loader: false });
      // message.error('Something went wrong', 10);
      errorHandle(props.ReportPdf.errors)
    }

    //get Franchise List
    if (props?.Setting?.franchise && Object.keys(props?.Setting?.franchise).length > 0 && 
      JSON.stringify(props?.Setting?.franchise) !== JSON.stringify(this.prop?.Settings?.franchise)) {
        
        this.setState({franchiseList: props?.Setting?.franchise.results});
    }

    if(Object.keys(props.dailyReports).length > 0&& props.dailyReports !== this.props?.dailyReports){
      this.setState({
        loader: false,
        dailyReports: props?.dailyReports?.results
      })
      // this.renderTableData(this.state.id)
    }

    // errors
    if (Object.keys(props.errors).length > 0 && JSON.stringify(props.errors) !== JSON.stringify(this.props.errors)) {
      this.setState({
        loader:false,
        errors: props.error
      })
      errorHandle(props.errors)
      // message.error('Something went wrong', 10);
    }

    if (Object.keys(props.CustomerStatementReport.customerList).length > 0 && 
      props.CustomerStatementReport.customerList !== this.props.CustomerStatementReport.customerList) {
      this.setState({
        customerList: props.CustomerStatementReport.customerList,
        loader: false,
        customerId: props.CustomerStatementReport.customerList[0].uuid,
        title: 'Customer Statement: '+ props.CustomerStatementReport.customerList[0].first_name + props.CustomerStatementReport.customerList[0].last_name,
        franchiseFilters: {
          user__uuid: props.CustomerStatementReport.customerList[0].uuid,
          invoice_date__range: `${moment().subtract(1, 'years').format('YYYY-MM-DD')},${moment().format('YYYY-MM-DD')}`
        }
      })
      props.getCSReport({
        user__uuid: props.CustomerStatementReport.customerList[0].uuid,
        invoice_date__range: `${moment().subtract(1, 'years').format('YYYY-MM-DD')},${moment().format('YYYY-MM-DD')}`
      })
    }

    if (Object.keys(props.CustomerStatementReport.customerReport).length > 0 && 
      props.CustomerStatementReport.customerReport !== this.props.CustomerStatementReport.customerReport) {
      let newCSR = []
      let  customerReport  = props?.CustomerStatementReport?.customerReport?.results
      for(let i = 0 ; i < customerReport.length; i ++ ){
        newCSR.push({
          "id": customerReport[i].id,
          "invoice_date": customerReport[i].invoice_date,
          "type": customerReport[i].type,
          "invoice_id": customerReport[i].invoice_id,
          "due_date": customerReport[i].due_date,
          "total_with_tax": customerReport[i].total_with_tax,
          "paid": '',
          "method": '',
          "balance_due":  customerReport[i].balance_due
        })
   
        if( customerReport[i].manual_payment.length > 0 ){
          for(let j = 0; j < customerReport[i].manual_payment.length; j++) {
            newCSR.push({
              "id": customerReport[i].manual_payment[j].id,
              "invoice_date": customerReport[i].manual_payment[j].created_at,
              "type": customerReport[i].manual_payment[j].type,
              "invoice_id": '',
              "due_date": '',
              "total_with_tax": '',
              "paid": customerReport[i].manual_payment[j].amount_received,
              "method": customerReport[i].manual_payment[j].method,
              "balance_due": ''  
            }) 
          }
        }
        if(customerReport[i].refunds.length > 0){
          for(let k = 0; k < customerReport[i].manual_payment.length; k++) {
            newCSR.push({
              "id": customerReport?.[i]?.refunds?.[k]?.id,
              "invoice_date": moment(customerReport?.[i]?.refunds?.[k]?.created_at).format('DD/MM/YYYY'),
              "type": 'Refund',
              "invoice_id": '',
              "due_date": '',
              "total_with_tax": '',
              "paid": customerReport?.[i]?.refunds?.[k]?.amount,
              "method": '',
              "balance_due": ''  
            }) 
          }
        }
      }
      this.setState({
        loader: false,
        customerReport: newCSR
      })
    }

    //revenue reports
    //zipcode
    if(Object.keys(props.RevenueReport.zipcodeList).length>0 && 
      props.RevenueReport.zipcodeList !== this.props.RevenueReport.zipcodeList){
      this.setState({
        revenueReportDetails:{
          ...this.state.revenueReportDetails,
          zipcodeList: props.RevenueReport.zipcodeList.zip_codes
        }
      })
    }

    if(Object.keys(props.RevenueReport.typeList).length>0 && 
      props.RevenueReport.typeList !== this.props.RevenueReport.typeList){
      this.setState({
        revenueReportDetails:{
          ...this.state.revenueReportDetails,
          typeList: [...props.RevenueReport.typeList.type]
        }
      })
    }

    if(Object.keys(props.RevenueReport.revenueReport).length>0 && 
      props.RevenueReport.revenueReport !== this.props.RevenueReport.revenueReport){
      this.setState({
        loader: false,
        revenueReportDetails:{
          ...this.state.revenueReportDetails,
          revenueReport: props.RevenueReport.revenueReport.results ? props.RevenueReport.revenueReport.results : props.RevenueReport.revenueReport,
          revenue_report_pagination: { 
            ...this.state.revenue_report_pagination,
            total: props.RevenueReport.revenueReport.count 
          }
        }
      })
    }

    if(Object.keys(props.RevenueReport.errors).length>0 && 
      props.RevenueReport.errors !== this.props.RevenueReport.errors){
      this.setState({
        loader: false
      })
      errorHandle(props.RevenueReport.errors)

      // message.error("Something went wrong", 10);
    }

    //Invoice Reconciliation report
    if(Object.keys(props?.InvoiceReconciliationReport?.report).length > 0 && 
      props?.InvoiceReconciliationReport?.report !== this.props.InvoiceReconciliationReport.report){
      this.setState({
        loader: false,
        invoiceReconciliationReport: props?.InvoiceReconciliationReport?.report,
      })
    }

    //customer complaints report
    if(Object.keys(props?.CustomerComplaintsReport?.report).length > 0 && 
      props?.CustomerComplaintsReport?.report !== this.props.CustomerComplaintsReport.report){
      this.setState({
        loader: false,
        customerComplaintsReport: props?.CustomerComplaintsReport?.report?.results,
        customer_complaints_report_pagination: { 
          ...this.state.customer_complaints_report_pagination,
          total: props?.CustomerComplaintsReport?.report?.count
        }
      })
    }

    if(Object.keys(props.CustomerComplaintsReport.tickets).length > 0 && 
      props.CustomerComplaintsReport.tickets !== this.props.CustomerComplaintsReport.tickets){
      this.setState({
        loader: false,
        reportdetails: true,
        customerComplaintsReport: [props?.CustomerComplaintsReport?.tickets?.franchise],
        customerComplaintsTickets: props?.CustomerComplaintsReport?.tickets?.results
      })
    }
    
    if(Object.keys(props.CustomerComplaintsReport.errors).length > 0 && 
      props.CustomerComplaintsReport.errors !== this.props.CustomerComplaintsReport.errors){
      this.setState({
        loader: false,
      })
      errorHandle(props.CustomerComplaintsReport.errors)
      
    }

    if (Object.keys(props.CommercialSalesReport.commercialReports).length > 0 &&
      props.CommercialSalesReport.commercialReports !== this.props?.CommercialSalesReport.commercialReports
    ) {
      if (props?.CommercialSalesReport.commercialReports?.results) {
        this.setState({
          loader: false,
          commercialReports: [...props.CommercialSalesReport.commercialReports.results],
          commercial_sales_report_pagination: { 
            ...this.state.commercial_sales_report_pagination,
            total: props?.CommercialSalesReport?.commercialReports?.count 
          }
  
        });
      } else {
        this.setState({
          loader: false,
          commercialReports: props?.CommercialSalesReport?.commercialReports,
          commercial_sales_report_pagination: { 
            ...this.state.commercial_sales_report_pagination,
            total: props?.CommercialSalesReport?.commercialReports?.count 
          }
        });
        
      }
    }

    if (Object.keys(props.CommercialSalesReport.commercialReportDetails).length > 0 &&
      props.CommercialSalesReport.commercialReportDetails !== this.props?.CommercialSalesReport?.commercialReportDetails
    ) {
      this.setState({
        loader: false,
        commercialReportDetails: props?.CommercialSalesReport?.commercialReportDetails
      });
    }

    if (Object.keys(props.CommercialSalesReport.errors).length > 0 &&
      JSON.stringify(props.CommercialSalesReport.errors) !== JSON.stringify(this.props.errors)
    ) {
      this.setState({
        loader: false,
        errors: props?.CommercialSalesReport?.error,
      });
      errorHandle(props.CommercialSalesReport.errors)
    }

    // customer Price Increase Report
    if (props?.CustomerPriceIncreaseReport.franchise.length > 0 &&
        props.CustomerPriceIncreaseReport.franchise !== this.props?.CustomerPriceIncreaseReport.franchise
    ) {
      this.setState({
        franchise: props?.CustomerPriceIncreaseReport.franchise
      });
    }
  
    if (Object.keys(props?.CustomerPriceIncreaseReport.userRoles).length > 0 &&
        props.CustomerPriceIncreaseReport.userRoles !== this.props?.CustomerPriceIncreaseReport.userRoles
    ) {
      this.setState({
        userRoles: [...props.CustomerPriceIncreaseReport.userRoles.display_name],
      });
    }
  
    if (Object.keys(props.CustomerPriceIncreaseReport.customerPriceIncreaseReport).length > 0 &&
        props.CustomerPriceIncreaseReport.customerPriceIncreaseReport !==
          this.props?.CustomerPriceIncreaseReport.customerPriceIncreaseReport
    ) {
      this.setState({
        loader: false,
        customerPriceIncreaseReport: props?.CustomerPriceIncreaseReport?.customerPriceIncreaseReport?.results,
        customer_price_increase_report_pagination: { 
          ...this.state.customer_price_increase_report_pagination,
          total: props?.CustomerPriceIncreaseReport?.customerPriceIncreaseReport?.count 
        }

      });
    }

    if(Object.keys(props?.CancellationReport?.report).length > 0 &&
        props?.CancellationReport?.report !== this.props.CancellationReport.report){
          
      this.setState({
        loader: false,
        cancellationReport: props?.CancellationReport?.report?.result,
        cancellation_report_pagination: { 
          ...this.state.cancellation_report_pagination,
          total: props?.CancellationReport?.report?.count 
        }
      })
    }

    if(Object.keys(props?.CancellationSummaryReport?.report).length > 0 &&
        props?.CancellationSummaryReport?.report !== this.props.CancellationSummaryReport.report){

      this.setState({
        loader: false,
        summaryReports: props?.CancellationSummaryReport?.report,
      })
    }

    if(props?.RoyaltyReport && Object.keys(props?.RoyaltyReport?.data).length > 0 &&
        props?.RoyaltyReport?.data !== this.props?.RoyaltyReport?.data){
      this.setState({
        loader: false,
        royaltyReport: props?.RoyaltyReport?.data.result,
      });
    }

    if(props?.ResidentialLeadReport && Object.keys(props?.ResidentialLeadReport?.data).length > 0 &&
        props?.ResidentialLeadReport?.data !== this.props?.ResidentialLeadReport?.data){

      this.setState({
        loader: false,
        residentialLeadReport: props?.ResidentialLeadReport?.data.results,
        lead_signup_report_pagination: { 
          ...this.state.lead_signup_report_pagination,
          offset: 0,
          limit: 15,
          total: props?.ResidentialLeadReport?.data?.count
        }

      });
    }

    // ResidentialSignupReport
    if(props?.ResidentialSignupReport && Object.keys(props?.ResidentialSignupReport?.data).length > 0 &&
        props?.ResidentialSignupReport?.data !== this.props?.ResidentialSignupReport?.data){

      this.setState({
        loader: false,
        residentialSignupReport: props?.ResidentialSignupReport?.data.results,
        lead_signup_report_pagination: { 
          ...this.state.lead_signup_report_pagination,
          offset: 0,
          limit: 15,
          total: props?.ResidentialSignupReport?.data?.count 
        }
      });
    }

    // CouponCodeReport
    if(props?.CouponCodeReport && Object.keys(props?.CouponCodeReport?.data).length > 0 &&
        props?.CouponCodeReport?.data !== this.props?.CouponCodeReport?.data){

      this.setState({
        loader: false,
        couponReport: props?.CouponCodeReport?.data.results,
        coupon_report_pagination: { 
          ...this.state.coupon_report_pagination,
          total: props?.CouponCodeReport?.data?.count 
        }
      });
    }

    if (Object.keys(props?.CommercialProposal?.list).length > 0 &&
      JSON.stringify(props?.CommercialProposal?.list) !== JSON.stringify(this.props?.CommercialProposal?.list)) {
        
      this.setState({ 
        loader: false,
        commercialProposalReport: props?.CommercialProposal?.list?.results,
        lead_signup_report_pagination: { 
          ...this.state.lead_signup_report_pagination,
          total: props?.CommercialProposal?.list?.count 
        }
      });
    }

    if(props?.CommercialSignupReport && Object.keys(props?.CommercialSignupReport?.data).length > 0 &&
        props?.CommercialSignupReport?.data !== this.props?.CommercialSignupReport?.data){

      this.setState({
        loader: false,
        commercialSignupReport: props?.CommercialSignupReport?.data.results,
        lead_signup_report_pagination: { 
          ...this.state.lead_signup_report_pagination,
          total: props?.CommercialSignupReport?.data?.count 
        }
      });
    }

    this.setState({loader: false});
    this.setState({loaderExport: false});
  }

  // get logged in user
  getLoggedInUserRole = () => {
    let authUser = JSON.parse(localStorage.getItem('authUser'))
    const logged_in_user_role = authUser?.user?.user_roles?.length > 0 ? authUser?.user?.user_roles?.map(x => x.name) : []
    const is_franchise_owner = logged_in_user_role?.includes('franchise_owner')
    // const is_account_corporate = logged_in_user_role?.includes('accounting_corporate')
    const is_business_dev_franchiese = logged_in_user_role?.includes('business_dev_franchiese')
    const is_operations_mgr = logged_in_user_role?.includes('operations_mgr')
    const is_field_tech = logged_in_user_role?.includes('field_tech')
    if (authUser.user!== null && authUser.user.associated_field_offices.length > 0) {
      return {
        franchise_name: authUser.user.associated_field_offices[0].name,
        franchise_uuid: authUser.user.associated_field_offices[0].uuid,
        is_disable_franchise: (is_franchise_owner || is_business_dev_franchiese || is_operations_mgr || is_field_tech)
      }
    } else {
      return {
        franchise_name: '',
        franchise_uuid: '',
        is_disable_franchise: (is_franchise_owner || is_business_dev_franchiese || is_operations_mgr || is_field_tech)
      }
    }
  }

  onSearch = (e) => {
    this.setState({search_value: e.target.value}, () => {
      const {id, search_value, customer_price_increase_report_pagination, active_pagination} = this.state;
      if (id === 'customer_price_increase_report' && (search_value?.length >= 3 || search_value?.length === 0)) {
        /*this.props.getCustomerPriceIncreaseReport({
          search: search_value, 
          offset: ((customer_price_increase_report_pagination.current - 1) * active_pagination), 
          limit: customer_price_increase_report_pagination?.pageSize
        });*/
        this.props.getCustomerPriceIncreaseReport({
          search: search_value, 
        });
      }
    });
  }

  buildReport = (id, date_range) => {
    const { customerId } = this.state
    if(id) {
      let customer = this.state.customerList.find(c => {
        return c.uuid === id
      })
      if(customer){
        this.setState({
          title: 'Customer Statement: ' + customer.first_name + ' ' + customer.last_name,
        })
      }
      this.setState({
        customerReport: [],
        franchiseFilters: {
          user__uuid: id,
          invoice_date__range: date_range
        }
      })
      this.props.getCSReport({
        user__uuid: id,
        invoice_date__range: date_range
      })
    } else {
      let customer = this.state.customerList.find(c => {
        return c.uuid === customerId
      })
      if(customer){
        this.setState({
          title: 'Customer Statement: ' + customer.first_name + ' ' + customer.last_name,
        })
      }
      this.setState({
        customerReport: [],
        franchiseFilters: {
          user__uuid: customerId,
          invoice_date__range: date_range
        }
      })
      this.props.getCSReport({
        user__uuid: customerId,
        invoice_date__range: date_range
      })
    }
  }

  buildDailyLogReport = (params) => {
    if(params.franchise_id){
      this.setState({
        reportdetails: true,
        franchiseFilters: params,
        dailyReports:[]
      })
    } else if(!params.franchise_id && params.search){
      this.setState({
        reportdetails: false,
        franchiseFilters: params,
        dailyReports:[]
      })
    }
    else{
      this.setState({
        reportdetails: false,
        franchiseFilters: params,
        dailyReports:[]
      })
    }
    this.props.getDailyLogReports(params)
  }

  updateCustomerDetails = (params) => {
    if(params.customerId){
      this.setState({customerId: params.customerId});
    }
  }

  buildCustomerReport = (params) => {
    if(params.id){
      this.setState({
        reportdetails: true,
        franchiseFilters: params
      });
      this.props.getRevenueReport({
        field_office_id: params.id,
        u_type: params.type.toLowerCase().replace(/ /g,"_")
      });
    } else if(!params.id && params.type){
      this.setState({
        reportdetails: false,
        franchiseFilters: params
      });
      this.props.getRevenueReport({
        u_type: params.type.toLowerCase().replace(/ /g,"_")
      });
    }else {
      this.setState({
        reportdetails: false,
        franchiseFilters:{}
      });
      this.props.getRevenueReport();
    }
  }

  buildCustomerComplaintsReport = (params) => {
    if(params.id && params.date_range){
      this.setState({
        loader: true,
        reportdetails: false,
        franchiseFilters: {        
          field_office_id: params.id,
          user__messages__created_at__date__range: params.date_range
        },
        customerComplaintsReport:[]
      })
      this.props.getCustomerComplaintsReport({
        field_office_id: params.id,
        user__messages__created_at__date__range: params.date_range
      })
    } else if(params.date_range && !params.id){
      this.setState({
        loader: true,
        reportdetails: false,
        franchiseFilters: {
          user__messages__created_at__date__range: params.date_range
        },
        customerComplaintsReport:[]
      })
      this.props.getCustomerComplaintsReport({
        user__messages__created_at__date__range: params.date_range
      })
    } else {
      this.setState({
        loader: true,
        reportdetails: false,
        franchiseFilters: {},
        customerComplaintsReport:[]
      })
      this.props.getCustomerComplaintsReport()
    }
  }

  buildInvoiceReconciliationReport = (params) => {
    this.setState({
      Fid:params.id
    })
    if(params.id && params.date_range){
      let dateRange = params.date_range.split(",");
      this.setState({
        loader: true,
        isValid:false,
        reportdetails: false,
        franchiseFilters: {        
          field_office_id: params.id,
          user__messages__created_at__date__range: params.date_range
        },
        invoiceReconciliationReport:[]
      })
      this.props.getInvoiceReconciliationReport({
        field_office_uuid: params.id,
        start_date: dateRange[0],
        end_date:dateRange[1]
      })
    }else{
      this.setState({
        isValid:true,
      })
    }
  }

  goToCustomerAccount = () =>{
    let customer = this.state.customerList.find(c => {
      return c.uuid === this.state.customerId
    })
    if(customer){
      if(customer.customer_type === 'residential'){
        this.props.history.push(`/residential/detail`, { query: { 'id': customer.uuid }})
      } else if(customer.customer_type === 'commercial'){
        this.props.history.push(`/commercial/customer-detail`, { query: { 'id': customer?.uuid } })
      }
    }
  }

  buildCommercialSalesReports = (params) => {
    let filters = Object.keys(params)
      .filter((k) => params[k] !== '')
      .reduce((a, k) => ({ ...a, [k]: params[k] }), {});
    this.setState({
      reportdetails: false,
    });
    this.setState({
      franchiseFilters: params,
      loader: true
    });

    this.props.getCommercialSalesReports(filters);
  };

  buildCustomerPriceIncreaseReport = (params) => {
    if (params.field_office_id !== undefined || params.field_office_uuid !== undefined){
      if(params.field_office_id !== '' || params.field_office_uuid !== '') {
        this.props.getCustomerPriceIncreaseReport(params);
        this.setState({
          loader: true,
          reportdetails: false,
          franchiseFilters: params,
          customerPriceIncreaseReport: [],
          selectedRowKeysUpdate: [],
          isValid: false,
          is_select_all_raised_price_increase: false
        });
      }
    } else {
      this.setState({
        loader: false,
        reportdetails: false,
        franchiseFilters: {},
        isValid: true,
      });
    }
  };

  buildCancellationReport = (params) => {
    this.props.getCancellationReport({...params, offset: 0, limit: 15});

    let data = {...params};
    delete data.ordering;
    delete data.cancelation_reason;

    this.props.getCancellationSummaryReport(data);

    if (params) {
      this.setState({
        reportdetails: false,
        franchiseFilters: params,
        cancellationReport: []
      });
    } else {
      this.setState({
        reportdetails: false,
        franchiseFilters: {},
      });
    }
  };

  buildRoyaltyReport = (params) => {
    this.props.getRoyaltyReport(params);

    if (params) {
      this.setState({
        reportdetails: false,
        filters: params,
        royaltyReport: []
      });
    } else {
      this.setState({
        reportdetails: false,
        filters: {
          field_office_uuids: [],
          end_date: moment().endOf('month').format('YYYY-MM-DD'),
          start_date: moment().startOf('month').format('YYYY-MM-DD')
        },
      });
    }
  };

  buildLeadSignupReport = (params) => {
    const filters = {
      ...params
    };

    if (params && params.stage !== '') {
      this.setState({
        loader: true,
        filters: filters,
        reportdetails: false,
      });

      if(params.customer_type === 'residential')
      {
        if(params.stage === 'lead') {
          this.props.getLeadReport(filters);
        }
        if(params.stage === 'signup') {
          this.props.getSignupReport(filters);
        }
      }
      else if(params.customer_type === 'commercial')
      {
        if(params.stage === 'lead') {
          this.props.getAllQuote(filters);
        }
        if(params.stage === 'signup') {
          this.props.getSignupCommercialReport(filters);
        }
      }
    } else {
      this.setState({
        loader: false,
        reportdetails: false,
        filters: {
          field_office_uuids: [],
        },
      });
    }
  }

  buildCouponReport = (params) => {
    const filters = {
      ...params,
      offset: 0,
      limit: 15
    };

    if (params) {
      this.setState({
        loader: true,
        filters: filters,
        reportdetails: false,
      });

      this.props.getCouponCodeReport(filters);

    } else {
      this.setState({
        loader: false,
        reportdetails: false,
        filters: {
          field_office_uuids: [],
        },
      });
    }
  }

  //Close drawer
  BatchUpdateToggle = (key) => {
    this.setState({
      is_Batch_Update_Selected_Customers: key,
    });
  };

  updateFilters = (filters) => {
    this.setState({
      filters,
      loader: true,
      lead_signup_report_pagination: {
        current: 1,
        pageSize: 15,
        showSizeChanger: false,
      },
      coupon_report_pagination: {
        current: 1,
        pageSize: 15,
        showSizeChanger: false,
      },
      active_pagination: '15'
    });
    this.setState({ isShowPaginationFooter: true});

    const id = this.props.location.state.query.id;

    switch(id)
    {
      case 'royalty-report':
        this.buildRoyaltyReport(filters);
        break;
      case 'lead_signup_report':
        this.buildLeadSignupReport(filters);
        break;
      case 'customer-cancelation-report':
        this.buildCancellationReport(filters);
        break;
      case 'coupon_report':
        this.buildCouponReport(filters);
        break;
    }
  }

  setStageAndCustomer = (stage, customer_type) => {
    this.setState({stage, customer_type});
  }

  loadSidebar = (id) => {
    switch(id) {
      case 'customer_statement': {
        return <ReportSidebar 
          title={this.state.title.split(':')[0]} 
          id={id} 
          customerList={this.state.customerList}
          resetFilters={this.resetFilters}
          buildReport={this.buildReport}
          updateCustomerDetails={this.updateCustomerDetails}
        />
      }

      case 'daily_log_report':{
        return <ReportSidebar 
          title={this.state.title} 
          id={id}
          customerList={this.state.customerList}
          franchiseList={this.state.franchiseList}
          resetFilters={this.resetFilters}
          buildReport={this.buildDailyLogReport}
          getLoggedInUserRole = {this.getLoggedInUserRole}
          onFiltersUpdate={this.updateFilters}
          {...this.props}
        />
      }

      case "in_territory_revenue_reports": {
        const { title, franchiseList } = this.state
        const { typeList } = this.state.revenueReportDetails
        return (
          <ReportSidebar
            title={title}
            id={id}
            franchiseList={franchiseList}
            typeList={typeList}
            customerList={this.state.customerList}
            resetFilters={this.resetFilters}
            buildReport={this.buildCustomerReport}
            getLoggedInUserRole = {this.getLoggedInUserRole}
          />
        );
      }

      case 'customer_complaints_report': {
        const { title, franchiseList } = this.state
        return <ReportSidebar
          title={title}
          id={id}
          franchiseList = {franchiseList}
          customerList={this.state.customerList}
          resetFilters = { this.resetFilters }
          buildReport = {this.buildCustomerComplaintsReport }
          getLoggedInUserRole = {this.getLoggedInUserRole}

        />
      }

      case 'invoice_revenue_report': {
        const { title, franchiseList } = this.state
        return <ReportSidebar
          title={title}
          id={id}
          isValid={this.state.isValid}
          franchise_List = {franchiseList}
          customerList={this.state.customerList}
          resetFilters = { this.resetFilters }
          buildReport = {this.buildInvoiceReconciliationReport }
          getLoggedInUserRole = {this.getLoggedInUserRole}
          report = {"invoice_revenue_report"}   
          {...this.props}       
        />
      }

      case "commercial_sales_report": {
        return (
          <ReportSidebar
            title={this.state.title}
            id={id}
            customerList={this.state.customerList}
            franchiseList={this.state.franchiseList}
            resetFilters={this.resetFilters}
            buildReport={this.buildCommercialSalesReports}
            getLoggedInUserRole = {this.getLoggedInUserRole}

          />
        );
      }

      case "customer-cancelation-report": {
        const { title, franchiseList } = this.state;

        return (
          <ReportSidebar
            id={id}
            franchiseList={franchiseList}
            resetFilters={this.resetFilters}
            customerList={this.state.customerList}
            summaryReports={this.state.summaryReports}
            buildReport={this.buildCancellationReport}
            getLoggedInUserRole = {this.getLoggedInUserRole}
            onFiltersUpdate={this.updateFilters}
            {...this.props}
          />
        );
      }

      case "customer_price_increase_report": {
        const {
          title,
          franchise,
          customerPriceIncreaseReport,
          userRoles,
        } = this.state;

        return (
          <ReportSidebar
            title={title}
            id={id}
            franchise={franchise}
            dataSource={customerPriceIncreaseReport}
            userRoles={userRoles}
            customerList={this.state.customerList}
            resetFilters={this.resetFilters}
            buildReport={this.buildCustomerPriceIncreaseReport}
            getLoggedInUserRole = {this.getLoggedInUserRole}
            isValid={this.state.isValid}
            {...this.props}  
          />
        );
      }

      case "royalty-report": {
        const { royaltyReport } = this.state;

        return (
          <ReportSidebar
            id={id}
            title={"Filter"}
            filters={this.filters}
            dataSource={royaltyReport}
            resetFilters={this.resetFilters}
            onFiltersUpdate={this.updateFilters}
            buildReport={this.buildRoyaltyReport}
            franchiseList={this.state.franchiseList}
            getLoggedInUserRole = {this.getLoggedInUserRole}
            {...this.props}
          />
        );
      }

      case "lead_signup_report": {
        return (
          <ReportSidebar
            id={id}
            title={"Filters"}
            filters={this.filters}
            resetFilters={this.resetFilters}
            setStageAndCustomer={this.setStageAndCustomer}
            onFiltersUpdate={this.updateFilters}
            buildReport={this.buildLeadSignupReport}
            getLoggedInUserRole = {this.getLoggedInUserRole}
            // dataSource={residentialLeadSignupReport}
            {...this.props}
          />
        );
      }

      case "coupon_report": {
        const { couponReport, franchiseList } = this.state;

        return (
          <ReportSidebar
            id={id}
            title={"Filters"}
            filters={this.filters}
            dataSource={couponReport}
            resetFilters={this.resetFilters}
            onFiltersUpdate={this.updateFilters}
            setStageAndCustomer={this.setStageAndCustomer}
            buildReport={this.buildCouponReport}
            getLoggedInUserRole = {this.getLoggedInUserRole}
            {...this.props}
          />
        );
      }

      default: {
        return this.props.history.push('/reports')
      }
    }
  }

  setUserPageLimit = (custom_limit) => {
    let { daily_log_report_pagination, franchiseFilters, daily_log_report_ordering } = this.state;
    daily_log_report_pagination = Object.assign(daily_log_report_pagination, { 'current': 1, 'pageSize': custom_limit });

    this.setState({
      daily_log_report_pagination,
      active_pagination: custom_limit,
      loader: true
    });

    let data = {
      ...franchiseFilters,
      ordering: daily_log_report_ordering,
      offset: 0, 
      limit: custom_limit
    }

    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    this.props.getDailyLogReports(data);
  }

  setCustomerStatementPageLimit = (custom_limit) => {
    let { customer_statement_report_pagination, franchiseFilters } = this.state;
    customer_statement_report_pagination = Object.assign(customer_statement_report_pagination, { 'current': 1, 'pageSize': custom_limit });

    this.setState({
      customer_statement_report_pagination,
      active_pagination: custom_limit,
    })
    let data = {
      ...franchiseFilters,
      offset: 0, limit: custom_limit
    }
    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    this.props.getCSReport(data);
  }

  setCustomerComplaintsPageLimit = (custom_limit) => {
    let { customer_complaints_report_pagination, franchiseFilters, commercial_sales_report_ordering } = this.state;
    customer_complaints_report_pagination = Object.assign(customer_complaints_report_pagination, { 'current': 1, 'pageSize': custom_limit });

    this.setState({
      customer_complaints_report_pagination,
      active_pagination: custom_limit,
      loader: true
    })
    let data = {
      ...franchiseFilters,
      ordering: commercial_sales_report_ordering,
      offset: 0, limit: custom_limit
    }
    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    this.props.getCustomerComplaintsReport(data);
  }

  setCommercialSalesPageLimit = (custom_limit) => {
    let { commercial_sales_report_pagination, franchiseFilters, commercial_sales_report_ordering } = this.state;
    commercial_sales_report_pagination = Object.assign(commercial_sales_report_pagination, { 'current': 1, 'pageSize': custom_limit });

    this.setState({
      commercial_sales_report_pagination,
      active_pagination: custom_limit,
      loader: true
    })
    let data = {
      ...franchiseFilters,
      ordering: commercial_sales_report_ordering,
      offset: 0, limit: custom_limit
    }
    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    this.props.getCommercialSalesReports(data);
  }

  setTerritoryRevenuePageLimit = (custom_limit) => {
    let { revenue_report_pagination, franchiseFilters } = this.state;
    revenue_report_pagination = Object.assign(revenue_report_pagination, { 'current': 1, 'pageSize': custom_limit });

    this.setState({
      revenue_report_pagination,
      active_pagination: custom_limit,
      loader: true
    })
    let data = {
      ...franchiseFilters,
      offset: 0, limit: custom_limit
    }
    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    this.props.getRevenueReport(data);
  }

  setCancellationReportPageLimit = (custom_limit) => {
    let { cancellation_report_pagination, franchiseFilters } = this.state;
    cancellation_report_pagination = Object.assign(cancellation_report_pagination, { 'current': 1, 'pageSize': custom_limit });

    this.setState({
      cancellation_report_pagination,
      active_pagination: custom_limit,
      loader: true
    });

    let data = {
      ...franchiseFilters,
      offset: 0,
      limit: custom_limit
    }

    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    this.props.getCancellationReport(data);
  }

  setPriceIncreaseUserPageLimit = (custom_limit) => {
    let { customer_price_increase_report_pagination, commercial_sales_report_ordering, franchiseFilters, search_value } = this.state;
    customer_price_increase_report_pagination = Object.assign(customer_price_increase_report_pagination, { 'current': 1, 'pageSize': custom_limit });

    /*this.setState({
      customer_price_increase_report_pagination,
      active_pagination: custom_limit,
      customerPriceIncreaseReport: [],
      loader: true
    })*/
    this.setState({
      customer_price_increase_report_pagination,
      active_pagination: custom_limit,
    })
    /*let data = {
      ...franchiseFilters,
      search: search_value,
      ordering: commercial_sales_report_ordering,
    }
    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    this.props.getCustomerPriceIncreaseReport(data);*/
  }

  setLeadSignupReportPageLimit = (custom_limit) => {
    let {
      stage,
      filters,
      customer_type,
      franchiseFilters,
      lead_signup_report_ordering,
      lead_signup_report_pagination,
    } = this.state;
    
    lead_signup_report_pagination = Object.assign(lead_signup_report_pagination, { 'current': 1, 'pageSize': custom_limit });

    let data = {
      ...filters,
      ...franchiseFilters,
      ordering: lead_signup_report_ordering,
      offset: 0, 
      limit: custom_limit,
    }
    
    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);

    if(customer_type === 'residential')
    {
      if(stage === 'lead' && 
        Object.keys(this.props?.ResidentialLeadReport?.data).length > 0)
      {
        this.setState({
          lead_signup_report_pagination,
          active_pagination: custom_limit,
          loader: true
        });
  
        this.props.getLeadReport(data);
      }
      else if (stage === 'signup' && 
        Object.keys(this.props?.ResidentialSignupReport?.data).length > 0)
      {
        this.setState({
          lead_signup_report_pagination,
          active_pagination: custom_limit,
          loader: true
        });
  
        this.props.getSignupReport(data);
      }
    }
    else if (customer_type === 'commercial')
    {
      if(stage === 'lead' && 
        Object.keys(this.props?.CommercialProposal?.list).length > 0)
      {
        this.setState({
          lead_signup_report_pagination,
          active_pagination: custom_limit,
          loader: true
        });
        
        this.props.getAllQuote(data);
      }
      else if (stage === 'signup' && 
      Object.keys(this.props?.CommercialSignupReport?.data).length > 0)
      {
        this.setState({
          lead_signup_report_pagination,
          active_pagination: custom_limit,
          loader: true
        });
        
        this.props.getSignupCommercialReport(data);
      }
    }
      
    else
    {
      this.setState({
        lead_signup_report_pagination,
        active_pagination: custom_limit,
      });
    }
  }

  setCouponReportPageLimit = (custom_limit) => {
    let { coupon_report_pagination,filters } = this.state;
    coupon_report_pagination = Object.assign(coupon_report_pagination, { 'current': 1, 'pageSize': custom_limit });

    this.setState({
      coupon_report_pagination,
      active_pagination: custom_limit,
      loader: true
    });

    let data = {
      ...filters,
      offset: 0,
      limit: custom_limit
    }

    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    this.props.getCouponCodeReport(data);
  }
  
  onReportHandleChange = (pagination, filters, sorter) => {
    let { daily_log_report_pagination, active_pagination, franchiseFilters, daily_log_report_ordering } = this.state;

    daily_log_report_pagination = Object.assign(daily_log_report_pagination, { 'current': pagination.current });
    let ordering = daily_log_report_ordering || '';

    if (sorter.column) {
      ordering = sorter.order === 'ascend' ? `${sorter.field}` : `-${sorter.field}`
    }
    else {
      ordering = ''
    }

    let data = {
      ...franchiseFilters,
      ordering,
      offset: (pagination.current * 15) - 15,
      limit: active_pagination
    }
    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    this.props.getDailyLogReports(data);
    this.setState({
      daily_log_report_pagination,
      daily_log_report_ordering: ordering,
      loader: true
    })
  }

  onTerritoryRevenueHandleChange = (pagination, filters, sorter) => {
    let { revenue_report_pagination, active_pagination, franchiseFilters } = this.state;
    revenue_report_pagination = Object.assign(revenue_report_pagination, { 'current': pagination.current });

    let ordering = ''
    if (sorter.column) {
      ordering = sorter.order === 'ascend' ? `${sorter.field}` : `-${sorter.field}`;
    }
    else {
      ordering = '';
    }

    let data = {
      ...franchiseFilters,
      ordering,
      offset: (pagination.current * 15) - 15,
      limit: active_pagination
    }
    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);

    this.setState({
      revenue_report_pagination,
      loader: true,
      revenueReportDetails: {
        revenueReport: [],
        ...this.state.revenueReportDetails
      }
    });

    this.props.getRevenueReport(data);
  }

  onCancellationReportHandleChange = (pagination, filters, sorter) => {
    let { cancellation_report_pagination, active_pagination, franchiseFilters } = this.state;
    cancellation_report_pagination = Object.assign(cancellation_report_pagination, { 'current': pagination.current });

    let ordering = ''
    if (sorter.column) {
      ordering = sorter.order === 'ascend' ? `${sorter.field}` : `-${sorter.field}`;
    }
    else {
      ordering = "first_name"; //default ordering by first_name
    }

    let data = {
      ...franchiseFilters,
      ordering,
      offset: (pagination.current * active_pagination) - active_pagination,
      limit: active_pagination
    }
    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);

    this.props.getCancellationReport(data);
  }

  onCustomerStatementHandleChange = (pagination, filters, sorter) => {
    let { customer_statement_report_pagination, active_pagination, franchiseFilters } = this.state;
    customer_statement_report_pagination = Object.assign(customer_statement_report_pagination, { 'current': pagination.current });

    let ordering = ''
    if (sorter.column) {
      ordering = sorter.order === 'ascend' ? `${sorter.field}` : `-${sorter.field}`;
    }
    else {
      ordering = '';
    }

    let data = {
      ...franchiseFilters,
      ordering,
      offset: (pagination.current * 15) - 15,
      limit: active_pagination
    }
    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    this.setState({
      customer_statement_report_pagination,
      loader: true
    })
    this.props.getCSReport(data);

  }

  onCustomerComplaintReportHandleChange = async (pagination, filters, sorter) => {
    let { customer_complaints_report_pagination, active_pagination, franchiseFilters, commercial_sales_report_ordering } = this.state;
    customer_complaints_report_pagination = Object.assign(customer_complaints_report_pagination, { 'current': pagination.current });

    let ordering = commercial_sales_report_ordering
    if (sorter.column) {
      ordering = sorter.order === 'ascend' ? `${sorter.field}` : `-${sorter.field}`;
    }
    else {
      ordering = '';
    }

    let data = {
      ...franchiseFilters,
      ordering,
      offset: (pagination.current * 15) - 15,
      limit: active_pagination
    }
    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);

    this.setState({customerComplaintsTickets: []});

    // this.state.reportdetails ? this.props.getCustomerComplaintsReportById(data) : this.props.getCustomerComplaintsReport(data)
    this.setState({loader : true});
    if(this.state.reportdetails) {
      await this.props.getCustomerComplaintsReportById(data);
    } else {
      this.setState({customerComplaintsReport: []});
      await this.props.getCustomerComplaintsReport(data);
    }
    this.setState({
      customer_complaints_report_pagination,
      commercial_sales_report_ordering: ordering
    });
  }

  onCommercialSalesHandleChange = (pagination, filters, sorter) => {
    let { commercial_sales_report_pagination, active_pagination, franchiseFilters, commercial_sales_report_ordering } = this.state;
    commercial_sales_report_pagination = Object.assign(commercial_sales_report_pagination, { 'current': pagination.current });

    let ordering = commercial_sales_report_ordering || '';
    if (sorter.column) {
      ordering = sorter.order === 'ascend' ? `${sorter.field}` : `-${sorter.field}`;
    }
    else {
      ordering = '';
    }

    let data
    if(this.state.reportdetails){
      data = {
        id: franchiseFilters.id,
        ordering
      }
    } else {
      data = {
        ...franchiseFilters,
        ordering,
        offset: (pagination.current * 15) - 15,
        limit: active_pagination
      }
    }

    this.setState({
      // commercialReports: [],
      commercialReportDetails: [],
      commercial_sales_report_pagination,
      commercial_sales_report_ordering: ordering,
      loader: true
    })

    
    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    // this.state.reportdetails ? this.props.getCommercialSalesReportsDetails(data) : this.props.getCommercialSalesReports(data)
    if(this.state.reportdetails) {
      this.props.getCommercialSalesReportsDetails(data)
    }
    else {
      this.setState({
        commercialReports : []
      })
      this.props.getCommercialSalesReports(data);
    }
  }

  onPriceIncreaseReportHandleChange = (pagination, filters, sorter) => {
    let { 
      customer_price_increase_report_pagination,
      active_pagination,
      franchiseFilters, search_value
    } = this.state;
    customer_price_increase_report_pagination = Object.assign(customer_price_increase_report_pagination, { 'current': pagination.current });

    /*let ordering = commercial_sales_report_ordering;
    if (sorter.column) {
      /**
       * AUTHOR: Ritesh Solanki
       * CHANGED: 13-10-2021 05:16 pm (Wednesday)
       * Replaced "joined" querystring params with "created_at"
       * <DOOD-3222>Price Increase Report | All the records are not getting displayed</DOOD-3222>
       */
     /* if (sorter.field === "joined") {
        ordering = sorter.order === 'ascend' ? `created_at` : `-created_at`;
      } else {
        ordering = sorter.order === 'ascend' ? `${sorter.field}` : `-${sorter.field}`;
      }      
    }
    else {
      ordering = '';
    }*/

    /*let data
    if(this.state.reportdetails){
      data = {
        ...franchiseFilters,
        ordering
      }
    } else {
      data = {
        ...franchiseFilters,
        ordering,
        offset: ((pagination.current - 1) * active_pagination),
        limit: pagination?.pageSize,
        search: search_value
      }
    }

    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);

    this.props.getCustomerPriceIncreaseReport(data)
    this.setState({
      customer_price_increase_report_pagination,
      commercial_sales_report_ordering: ordering,
      loader: true
    })*/
  }

  onRoyaltyReportHandleChange = (pagination, sorter) => {
    let { royalty_report_ordering, active_pagination, filters, search_value } = this.state;
    // royalty_report_pagination = Object.assign(royalty_report_pagination, { 'current': pagination.current });

    let ordering = royalty_report_ordering;
    if (sorter.column) {
      if (sorter.field === "joined") {
        ordering = sorter.order === 'ascend' ? `created_at` : `-created_at`;
      } else {
        ordering = sorter.order === 'ascend' ? `${sorter.field}` : `-${sorter.field}`;
      }      
    }
    else {
      ordering = '';
    }

    let data
    if(this.state.reportdetails){
      data = {
        ...filters,
        ordering
      }
    } else {
      data = {
        ...filters,
        ordering,
        offset: 0,
        search: search_value
      }
    }

    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);

    this.props.getRoyaltyReport(data);
    this.setState({
      royalty_report_ordering: ordering,
      loader: true
    });
  }

  onLeadSignupReportHandleChange = (pagination, sorter) => {
    let {
      stage,
      filters,
      show_warning,
      // search_value,
      active_pagination,
      lead_signup_report_ordering,
      lead_signup_report_pagination,
    } = this.state;

    lead_signup_report_pagination = Object.assign(lead_signup_report_pagination, { 'current': pagination.current });

    let ordering = lead_signup_report_ordering || '';

    if (sorter.column) {
      if (sorter.field === "joined") {
        ordering = sorter.order === 'ascend' ? `created_at` : `-created_at`;
      } else {
        ordering = sorter.order === 'ascend' ? `${sorter.field}` : `-${sorter.field}`;
      }      
    }
    else {
      ordering = '';
    }

    let data = {
      ...filters,
      ordering,
      limit: active_pagination,
      offset: ((pagination.current - 1) * active_pagination)
    }

    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    this.setState({
      lead_signup_report_pagination,
      loader: true
    });

    if(this.state.customer_type === 'residential')
    {
      if(stage === 'lead')
      {
        this.props.getLeadReport(data);
      }

      if(stage === 'signup')
      {
        this.props.getSignupReport(data);
      }
    }
    else if(this.state.customer_type === 'commercial')
    {
      if(stage === 'lead')
      {
        this.props.getAllQuote(data);
      }

      if(stage === 'signup')
      {
        this.props.getSignupCommercialReport(data);
      }
    }

  }

  onCouponReportHandleChange = (pagination, sorter) => {
    let {
      filters,
      active_pagination,
      coupon_report_ordering,
      coupon_report_pagination,
    } = this.state;

    coupon_report_pagination = Object.assign(coupon_report_pagination, { 'current': pagination.current });

    let ordering = coupon_report_ordering || '';
    let data = {
      ...filters,
      ordering,
      limit: active_pagination,
       offset: (pagination.current * active_pagination) - active_pagination,
    }

    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    this.setState({
      coupon_report_pagination,
      loader: true
    });
    this.props.getCouponCodeReport(data);
  }

  onLeadSignupExport = () => {
    const {
      stage,
      filters,
      show_warning,
      customer_type
    } =  this.state;
    this.setState({loaderExport: true});

    if(customer_type === 'residential')
    {
      if(stage === 'lead') 
      {
        this.props.getLeadReportCSV(filters);
      }
      else if(stage === 'signup')
      {
        this.props.getSignupReportCSV(filters);
      }
    }
    else if(customer_type === 'commercial')
    {
      if(stage === 'lead') 
      {
        this.props.getProposalReportCSV(filters);
      }
      else if(stage === 'signup')
      {
        this.props.getSignupCommercialReportCSV(filters);
      }
    }

    if(!show_warning)
      {
        this.setState({show_warning: true});
      }
  }

  renderReportDetails = (id) => {
    // let { report_pagination } = this.state
    switch(id) 
    {
      case 'daily_log_report': {
        let { dailyReports,franchiseList, franchiseFilters, daily_log_report_pagination } = this.state
            
        let franchise = franchiseList.find(f => {
          return f.id === franchiseFilters.franchise_id
        });

        return (<React.Fragment>
          <div className="card">
            <div className="card-title">
              <div className="fitem">
                <label>Franchise</label>
                <h4>{franchise.name}</h4>
              </div>
            </div>

            <div className="card-body" style={{width: "max-content"}}>
              <Table
                rowKey={record => record.id}
                dataSource={dailyReports}
                columns={DataTable.DailyLogReportDetail(this)}
                className="table hscroll report-tbl border-around inner-table"
                pagination={daily_log_report_pagination}
                onChange={this.onReportHandleChange}
              />
            </div>
          </div>
        </React.Fragment>)
      }

      case 'customer_complaints_report': {
        const { customerComplaintsTickets, customerComplaintsReport, customer_complaints_report_pagination } = this.state
        return (<React.Fragment>
          <div className="card">
            <div className="card-title">
              <div className = 'form-group flex ai-center w-100 fltr-txt pt-10 ccr-block'>
                <div className="fitem half-fitem d-block franch-min-w">
                  <label className="d-block helper-text">Franchise</label>
                  <h6 className="mb-0 font-weight-bold">{customerComplaintsReport[0].name}</h6>
                </div>
                <div className="fitem half-fitem d-block">
                  <label className="d-block helper-text">Services Completed</label>
                  <h6 className="mb-0">{customerComplaintsReport[0].service_completed}</h6>
                </div>
                <div className="fitem  half-fitem d-block">
                  <label className="d-block helper-text">Complaints%</label>
                  <h6 className="mb-0">{customerComplaintsReport[0].complaints}</h6>
                </div>
                <div className="fitem half-fitem d-block min-w-85">
                  <label className="d-block helper-text"><img width="16" src={smile_icon} alt="" className="emoji-icon"/> %</label>
                  <h6 className="mb-0">{customerComplaintsReport[0].happy}</h6>
                </div>
                <div className="fitem half-fitem d-block min-w-85">
                  <label className="d-block helper-text"><img width="16" src={neutral_icon} alt="" className="emoji-icon"/> %</label>
                  <h6 className="mb-0">{customerComplaintsReport[0].neutral}</h6>
                </div>
                <div className="fitem half-fitem d-block min-w-85">
                  <label className="d-block helper-text"><img width="16" src={sad_icon} alt="" className="emoji-icon"/> %</label>
                  <h6 className="mb-0">{customerComplaintsReport[0].sad}</h6>
                </div>
              </div>
            </div>
            <div className="card-body">
              <Table 
                rowKey={(record) => record.id}
                dataSource={customerComplaintsTickets}
                columns={DataTable.CustomerComplaintsReportDetails(this)}
                className="table hscroll border-around inner-table"
                pagination={customer_complaints_report_pagination}
                onChange={this.onCustomerComplaintReportHandleChange}
              />
            </div>
          </div>
        </React.Fragment>)
      }

      case "commercial_sales_report": {
        let { commercialReportDetails, franchiseList, franchiseFilters,commercialReports, commercial_sales_report_pagination } = this.state;
        let franchise = franchiseList.find((f) => {
          return f.id === franchiseFilters.id;
        });
        return (
          <React.Fragment>
            <div className="card">
              {franchise ? (
                <div className="card-title">
                  <div className = 'form-group flex ai-center w-100 fltr-txt pt-10 ccr-block'>
                    <div className="fitem half-fitem d-block franch-min-w">
                      <label className="d-block helper-text">Franchise</label>
                      <h6 className="mb-0 font-weight-bold">{franchise.name}</h6>
                    </div>
                    <div className="fitem half-fitem d-block">
                      <label className="d-block helper-text">New Rev</label>
                      <h6 className="mb-0">{commercialReports[0].new_rev}</h6>
                    </div>
                    <div className="fitem  half-fitem d-block">
                      <label className="d-block helper-text">#</label>
                      <h6 className="mb-0">{commercialReports[0].revenue_count}</h6>
                    </div>
                    <div className="fitem half-fitem d-block min-w-85">
                      <label className="d-block helper-text">Repairs</label>
                      <h6 className="mb-0">{commercialReports[0].repairs}</h6>
                    </div>
                    <div className="fitem half-fitem d-block min-w-85">
                      <label className="d-block helper-text">#</label>
                      <h6 className="mb-0">{commercialReports[0].repair_count}</h6>
                    </div>
                  </div>

                </div>
              ) : (
                <div></div>
              )}

              <div className="card-body">
                <Table
                  rowKey={(record) => record.id}
                  dataSource={commercialReportDetails}
                  columns={DataTable.CommercialSalesReportsDetail(this)}
                  className="table hscroll border-around inner-table"
                  pagination={commercial_sales_report_pagination}
                  onChange={this.onCommercialSalesHandleChange}
                />
              </div>
            </div>
          </React.Fragment>
        );
      }

      case "customer_price_increase_report": {
        let {
          customerPriceIncreaseReport,
          selectedRowKeysUpdate,
          customer_price_increase_report_pagination
        } = this.state;
        return (
          <React.Fragment>
            <div className="card">
              <div className="card-body">
                <Table
                  rowKey={(record) => record.id}
                  dataSource={customerPriceIncreaseReport}
                  pagination={customer_price_increase_report_pagination}
                  onChange={this.onReportHandleChange}
                  rowSelection={{                    
                    type: "checkbox",
                    selectedRowKeys: selectedRowKeysUpdate,
                    onChange: this.onSelectedRowKeysUpdateChange,
                  }}
                  columns={DataTable.CustomerPriceIncreaseReportDetails(this)}
                />
              </div>
            </div>
          </React.Fragment>
        );
      }

      case 'customer-cancelation-report': {
        let { franchiseList, franchiseFilters, cancellation_report_pagination , cancellationReport} = this.state;
        let franchise = franchiseList.find(f => {
          return f.id === franchiseFilters.id
        })
        return (<React.Fragment>
          <div className="card">
            <div className="card-title">
              <div className="fitem">
                <label>Franchise</label>
                <h4>{franchise.name}</h4>
              </div>
            </div>
            <div className="card-body">
              <Table 
                rowKey={(record) => record.id}
                dataSource={cancellationReport}
                columns={DataTable.CancellationReportDetailsColumns(this)}
                className="table hscroll"
                pagination={cancellation_report_pagination}
                onChange={this.onCancellationReportHandleChange}
              />
            </div>
          </div>
        </React.Fragment>)
      }

      case 'royalty-report': {
        let {
          filters,
          franchiseList,
          royaltyReport,
          // royalty_report_pagination
        } = this.state;
        let franchise = franchiseList.find(f => {
          return f.id === filters.franchise.id
        });

        return (<React.Fragment>
          <div className="card">
            <div className="card-title">
              <div className="fitem">
                <label>Royalty Report</label>
              </div>
            </div>
            <div className="card-body">
              <Table 
                pagination={false}
                className="table hscroll"
                rowClassName={(record, index) =>
                  record.is_main ? 'main-row' : ''
                }
                dataSource={royaltyReport}
                rowKey={(record) => record.id}
                columns={DataTable.royaltyReportDetailsColumns(this)}
                onChange={this.onRoyaltyReportHandleChange}
              />
            </div>
          </div>
        </React.Fragment>)
      }

      case 'lead_signup_report': {
        let {
          stage,
          filters,
          customer_type,
          franchiseList,
          residentialLeadReport,
          residentialSignupReport,
          lead_signup_report_pagination
        } = this.state;

        let franchise = franchiseList.find(f => {
          return f.id === filters.franchise.id
        });

        this.renderLeadSignupTable();
      }

      case 'coupon_report':
      {
        let {
          filters,
          couponReport,
          franchiseList,
          coupon_report_pagination
        } = this.state;

        let franchise = franchiseList.find(f => {
          return f.id === filters.franchise.id
        });
        
        return (<React.Fragment>
          <div className="card">
            <div className="card-title">
              <div className="fitem">
                <label>Coupon Code Report</label>
              </div>
            </div>
            <div className="card-body">
              <Table 
                className="table hscroll"
                rowKey={(record) => record.id}
                dataSource={couponReport}
                pagination={coupon_report_pagination}
                columns={DataTable.couponReportDetailsColumns(this)}
                onChange={this.onCouponReportHandleChange}
              />
            </div>
          </div>
        </React.Fragment>)
      }
      default: {
        this.props.history.push(`/reports/report`, { query: { 'id': id } })
      }
    }
  }

  renderLeadSignupTable = () => {
    const {
      stage,
      customer_type,
      residentialLeadReport,
      commercialSignupReport,
      residentialSignupReport,
      commercialProposalReport,
      lead_signup_report_pagination
    } = this.state;

    if (customer_type === 'residential')
    {
      if (stage === 'lead')
      {
        return (<React.Fragment>
          <div className="card-body">
            <Table 
              className="table hscroll"
              rowKey={(record) => record.id}
              dataSource={residentialLeadReport}
              pagination={lead_signup_report_pagination}
              columns={DataTable.ResidentialLeadReportDetails(this)}
              onChange={this.onLeadSignupReportHandleChange}
            />
          </div>
        </React.Fragment>)
      }
      else
      {
        return (<React.Fragment>
          <div className="card-body">
            <Table 
              className="table hscroll"
              rowKey={(record) => record.id}
              dataSource={residentialSignupReport}
              pagination={lead_signup_report_pagination}
              columns={DataTable.ResidentialSignupReportDetails(this)}
              onChange={this.onLeadSignupReportHandleChange}
            />
          </div>
        </React.Fragment>)
      }
    }
    else if (customer_type === 'commercial')
    {
      if(stage === 'lead')
      {
        return (<React.Fragment>
          <div className="card-body">
            <Table 
              className="table hscroll"
              rowKey={(record) => record.id}
              dataSource={commercialProposalReport}
              pagination={lead_signup_report_pagination}
              columns={DataTable.CommercialProposalReportDetails(this)}
              onChange={this.onLeadSignupReportHandleChange}
            />
          </div>
        </React.Fragment>)
      }
      else
      {
        return (<React.Fragment>
          <div className="card-body">
            <Table 
              className="table hscroll"
              rowKey={(record) => record.id}
              dataSource={commercialSignupReport}
              pagination={lead_signup_report_pagination}
              columns={DataTable.CommercialSignupReportDetails(this)}
              onChange={this.onLeadSignupReportHandleChange}
            />
          </div>
        </React.Fragment>)
      }
    }
  }

  renderTableData = (id) => {
    let {active_pagination } = this.state

    switch(id) 
    {
      case 'customer_statement': {
        let  {customerReport, customer_statement_report_pagination}  = this.state
        return (<React.Fragment>
          <div id="printTable">
            <Table
              rowKey={record => record.id}
              dataSource={customerReport}
              columns={DataTable.CustomerStatementReport(this)}
              className="table hscroll inner-table-multiple"
              pagination={customer_statement_report_pagination}
              onChange={this.onCustomerStatementHandleChange}
            />
          </div>
          <ul className="pagination_page_size">
            <li>
              <span>Show:</span>
            </li>
            <li>
              <span
                onClick={() => { this.setCustomerStatementPageLimit('15') }}
                className={active_pagination === '15' ? 'active' : ''}
              >15</span>
            </li>
            <li>
              <span
                className={active_pagination === '30' ? 'active' : ''}
                onClick={() => { this.setCustomerStatementPageLimit('30') }}>30</span>
            </li>
            <li>
              <span
                className={active_pagination === '60' ? 'active' : ''}
                onClick={() => { this.setCustomerStatementPageLimit('60') }}>60</span>
            </li>
          </ul>
        </React.Fragment>
        )
      }

      case 'daily_log_report': {
        let { dailyReports, franchiseFilters, daily_log_report_pagination } = this.state
        if(franchiseFilters.search){
          return (<React.Fragment>
            <div className="card">
              <div className="card-title">
                <div className="fitem">
                  <label>Individual Customer Rep</label>
                  <h4>{franchiseFilters.search}</h4>
                </div>
              </div>
      
              <div className="card-body">
                <Table
                  rowKey={record => record.id}
                  dataSource={dailyReports}
                  columns={DataTable.DailyLogReport(this)}
                  className="table hscroll border-around inner-table"
                  pagination={daily_log_report_pagination}
                  onChange={this.onReportHandleChange}
                />

                <ul className="pagination_page_size">
                  <li>
                    <span>Show:</span>
                  </li>
                  <li>
                    <span
                      onClick={() => { this.setUserPageLimit('15') }}
                      className={active_pagination === '15' ? 'active' : ''}
                    >15</span>
                  </li>
                  <li>
                    <span
                      className={active_pagination === '30' ? 'active' : ''}
                      onClick={() => { this.setUserPageLimit('30') }}>30</span>
                  </li>
                  <li>
                    <span
                      className={active_pagination === '60' ? 'active' : ''}
                      onClick={() => { this.setUserPageLimit('60') }}>60</span>
                  </li>
                </ul>
              </div>
            </div>
          </React.Fragment>)  
        } else {
          return (<React.Fragment>
            <Table
              rowKey={record => record.id}
              dataSource={dailyReports}
              columns={DataTable.DailyLogReport(this)}
              className="table hscroll border-around inner-table"
              pagination={daily_log_report_pagination}
              onChange={this.onReportHandleChange}
            />
      
            <ul className="pagination_page_size">
              <li>
                <span>Show:</span>
              </li>
              <li>
                <span
                  onClick={() => { this.setUserPageLimit('15') }}
                  className={active_pagination === '15' ? 'active' : ''}
                >15</span>
              </li>
              <li>
                <span
                  className={active_pagination === '30' ? 'active' : ''}
                  onClick={() => { this.setUserPageLimit('30') }}>30</span>
              </li>
              <li>
                <span
                  className={active_pagination === '60' ? 'active' : ''}
                  onClick={() => { this.setUserPageLimit('60') }}>60</span>
              </li>
            </ul>
          </React.Fragment>)
        
        }
      }

      case "in_territory_revenue_reports": {
        const { revenueReport, revenue_report_pagination } = this.state.revenueReportDetails
        return <React.Fragment>
          <Table 
            rowKey={(record) => record.id}
            dataSource={revenueReport}
            columns={DataTable.InTerritoryRevenueReport(this)}
            className="table hscroll"
            pagination={revenue_report_pagination}
            onChange={this.onTerritoryRevenueHandleChange}
          />
          
          <ul className="pagination_page_size">
            <li>
              <span>Show:</span>
            </li>
            <li>
              <span
                onClick={() => { this.setTerritoryRevenuePageLimit('15') }}
                className={active_pagination === '15' ? 'active' : ''}
              >15</span>
            </li>
            <li>
              <span
                className={active_pagination === '30' ? 'active' : ''}
                onClick={() => { this.setTerritoryRevenuePageLimit('30') }}>30</span>
            </li>
            <li>
              <span
                className={active_pagination === '60' ? 'active' : ''}
                onClick={() => { this.setTerritoryRevenuePageLimit('60') }}>60</span>
            </li>
          </ul>
        </React.Fragment>
      }

      case 'customer_complaints_report': {
        const { customerComplaintsReport, customer_complaints_report_pagination } = this.state
        return <React.Fragment>
          <Table 
            rowKey={(record) => record.id}
            dataSource={customerComplaintsReport}
            columns={DataTable.CustomerComplaintsReport(this)}
            className="table hscroll"
            pagination={customer_complaints_report_pagination}
            onChange={this.onCustomerComplaintReportHandleChange}
          /> 

          <ul className="pagination_page_size">
            <li>
              <span>Show:</span>
            </li>
            <li>
              <span
                onClick={() => { this.setCustomerComplaintsPageLimit('15') }}
                className={active_pagination === '15' ? 'active' : ''}
              >15</span>
            </li>
            <li>
              <span
                className={active_pagination === '30' ? 'active' : ''}
                onClick={() => { this.setCustomerComplaintsPageLimit('30') }}>30</span>
            </li>
            <li>
              <span
                className={active_pagination === '60' ? 'active' : ''}
                onClick={() => { this.setCustomerComplaintsPageLimit('60') }}>60</span>
            </li>
          </ul>
        </React.Fragment>
      }

      case 'invoice_revenue_report': {
        const { invoiceReconciliationReport,franchiseFilters} = this.state
        let searchValue = !_.isEmpty(franchiseFilters.search)?franchiseFilters.search.split(','):['products','services','discount','tax'];
        searchValue = !_.isEmpty(searchValue)?searchValue.map(value => value.trim().toLowerCase()):['products','services','discount','tax'];
        return <React.Fragment>
          <div className="report-table">
            <div className="card">
              <div className="card-title">
                {_.isEmpty(invoiceReconciliationReport.franchise) && this.state.Fid!==null?<div style={{textAlign:'center', color:'red'}}>No Record Found!</div>:<div className="form-group flex ai-center w-100 fltr-txt pt-10 ccr-block">
                  <div className="fitem half-fitem d-block franch-min-w franch-min-w-inv">
                    <label className="d-block helper-text">Franchise</label>
                    <h6 className="mb-0 font-weight-bold">{!_.isEmpty(invoiceReconciliationReport.franchise)?invoiceReconciliationReport.franchise:"--"}</h6>
                  </div>
                  <div className="fitem half-fitem d-block" style={{marginLeft: '-65px'}}>
                    <label className="d-block helper-text">Time Period</label>
                    <h6 className="mb-0 font-weight-bold">{!_.isEmpty(invoiceReconciliationReport)?`${moment(invoiceReconciliationReport.time_period.split("#")[0]).format('ll')} - ${moment(invoiceReconciliationReport.time_period.split("#")[1]).format('ll')}`:"--"}</h6>
                  </div>
                  <div className="fitem half-fitem d-block">
                    <label className="d-block helper-text">Total Jobs Completed ($)</label>
                    <h6 className="mb-0 font-weight-bold">
                        ${!_.isEmpty(invoiceReconciliationReport) && !_.isEmpty(invoiceReconciliationReport.franchise) ? formatToCurrency(invoiceReconciliationReport.total_jobs_completed_value) : '0.00'}
                    </h6>
                  </div>
                  <div className="fitem half-fitem d-block">
                    <label className="d-block helper-text">Total Jobs Completed & Invoiced with Tax($)</label>
                    <h6 className="mb-0 font-weight-bold">
                        ${!_.isEmpty(invoiceReconciliationReport) && !_.isEmpty(invoiceReconciliationReport.franchise) ? formatToCurrency(invoiceReconciliationReport.total_invoiced) : '0.00'}
                    </h6>
                    <label className="d-block helper-text">Total Jobs Completed & Invoiced without Tax($) </label>
                    <h6 className="mb-0 font-weight-bold">
                        ${!_.isEmpty(invoiceReconciliationReport) && !_.isEmpty(invoiceReconciliationReport.franchise) ? formatToCurrency(invoiceReconciliationReport.total_invoiced - invoiceReconciliationReport.sales_tax.total_invoiced) : '0.00'}
                    </h6>
                  </div>
                  <div className="fitem half-fitem d-block">
                    <label className="d-block helper-text">Jobs Completed but not Invoiced ($)</label>
                    <h6 className="mb-0 font-weight-bold">
                        ${!_.isEmpty(invoiceReconciliationReport) && !_.isEmpty(invoiceReconciliationReport.franchise) ? formatToCurrency(invoiceReconciliationReport.total_jobs_completed_value - (invoiceReconciliationReport.total_invoiced - invoiceReconciliationReport.sales_tax.total_invoiced) ) : '0.00'}
                    </h6>
                  </div>
                </div>}
              </div>
              <div className="card-body">
                {searchValue.includes('products')?
                  <div className="ant-table-wrapper table hscroll border-around inner-table inv">
                    <div className="ant-spin-nested-loading">
                      <div className="ant-table">
                        <div className="ant-table-container">
                          <div className="ant-table-content">
                            <table style={{tableLayout: 'auto'}}>
                              <colgroup></colgroup>
                              <thead className="ant-table-thead">
                                <tr>
                                  <th className="ant-table-cell tname invname th-invoice-rec">Products</th>
                                  <th className="ant-table-cell tname invname th-invoice-inv">Jobs Completed ($)</th>
                                  <th className="ant-table-cell tname invname th-invoice-com">Jobs Completed & Invoiced ($)</th>
                                  <th className="ant-table-cell tname invname th-invoice-com">Jobs Completed but not Invoiced ($)</th>
                                </tr>
                              </thead>
                              {!_.isEmpty(invoiceReconciliationReport) && !_.isEmpty(invoiceReconciliationReport.franchise)?
                                invoiceReconciliationReport.products.product_list.map((products,i)=>(
                                  <tbody key={i} className="ant-table-tbody">
                                    <tr className="ant-table-row ant-table-row-level-0">
                                      <td className="ant-table-cell tname th-invoice-rec th-font-weight">
                                        <span className="type ellipse ellipse-inline">{products.name}</span>
                                      </td>                                      
                                      <td className="ant-table-cell tname th-invoice-com">
                                        <span className="type ellipse ellipse-inline">${formatToCurrency(products.completed_price)}</span>
                                      </td>
                                      <td className="ant-table-cell tname th-invoice-com">
                                        <span className="type ellipse ellipse-inline">${formatToCurrency(products.invoiced_price)}</span>
                                      </td>
                                      <td className="ant-table-cell tname th-invoice-inv">
                                        <span className="type ellipse ellipse-inline">${formatToCurrency(products.completed_not_invoiced)}</span>
                                      </td>
                                    </tr>
                                  </tbody>
                                )):
                                <tbody className="ant-table-tbody">
                                  <tr className="ant-table-row ant-table-row-level-0">
                                    <td className="ant-table-cell tname th-invoice-rec th-font-weight">
                                      <span className="type ellipse ellipse-inline">--</span>
                                    </td>
                                    <td className="ant-table-cell tname th-invoice-inv">
                                      <span className="type ellipse ellipse-inline">--</span>
                                    </td>
                                    <td className="ant-table-cell tname th-invoice-com">
                                      <span className="type ellipse ellipse-inline">--</span>
                                    </td>
                                  </tr>
                                </tbody>
                              }
                              {!_.isEmpty(invoiceReconciliationReport) && !_.isEmpty(invoiceReconciliationReport.franchise)?
                                <tfoot className="ant-table-thead">
                                  <tr>
                                    <th className="ant-table-cell tname th-invoice-rec invoice_rec_total">Total</th>                                    
                                    <th className="ant-table-cell tname th-invoice-inv invoice_rec_total">
                                        ${invoiceReconciliationReport.products.total_completed ? formatToCurrency(invoiceReconciliationReport.products.total_completed) : 0}
                                    </th>
                                    <th className="ant-table-cell tname th-invoice-com invoice_rec_total">
                                        ${invoiceReconciliationReport.products.total_invoiced ? formatToCurrency(invoiceReconciliationReport.products.total_invoiced) : 0}                                        
                                    </th>
                                    <th className="ant-table-cell tname th-invoice-com invoice_rec_total">
                                        ${invoiceReconciliationReport.products.total_completed_not_invoiced ? formatToCurrency(invoiceReconciliationReport.products.total_completed_not_invoiced) : 0}                                        
                                    </th>
                                  </tr>
                                </tfoot>:null}
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>:null}
                {searchValue.includes('services')?
                  <div className="ant-table-wrapper table hscroll border-around inner-table my-20 inv">
                    <div className="ant-spin-nested-loading">
                      <div className="ant-table">
                        <div className="ant-table-container">
                          <div className="ant-table-content">
                            <table style={{tableLayout: 'auto'}}>
                              <colgroup></colgroup>
                              <thead className="ant-table-thead">
                                <tr>
                                  <th className="ant-table-cell tname th-invoice-rec">Services</th>
                                  <th className="ant-table-cell tname invname th-invoice-inv">Jobs Completed ($)</th>
                                  <th className="ant-table-cell tname invname th-invoice-com">Jobs Completed & Invoiced ($)</th>
                                  <th className="ant-table-cell tname invname th-invoice-com">Jobs Completed but not Invoiced ($)</th>
                                </tr>
                              </thead>
                              {!_.isEmpty(invoiceReconciliationReport) && !_.isEmpty(invoiceReconciliationReport.franchise)?
                                invoiceReconciliationReport.services.service_list.map((service,i)=>(
                                  !_.isEmpty(service.services) && !_.isEmpty(invoiceReconciliationReport.franchise)?<tbody key={i} className="ant-table-tbody">
                                    <tr className="ant-table-thead invoice_rec_services">
                                      <th colSpan="4" style={{textAlign:"left"}}>{service.service_name}</th>
                                    </tr>
                                    {service.services.map((servicelist,i)=>(
                                      <tr key={i} className="ant-table-row ant-table-row-level-0">
                                        <td className="ant-table-cell tname th-invoice-rec inv-service-list th-font-weight">
                                          <span className="type ellipse ellipse-inline">{servicelist.name === "Areas to clean"? "Additional areas":servicelist.name}</span>
                                        </td>                                        
                                        <td className="ant-table-cell tname th-invoice-com">
                                          <span className="type ellipse ellipse-inline">${formatToCurrency(servicelist.completed_price)}</span>
                                        </td>
                                        <td className="ant-table-cell tname th-invoice-inv">
                                          <span className="type ellipse ellipse-inline">${formatToCurrency(servicelist.invoiced_price)}</span>
                                        </td>
                                        <td className="ant-table-cell tname th-invoice-inv">
                                          <span className="type ellipse ellipse-inline">${formatToCurrency(servicelist.completed_not_invoiced)}</span>
                                        </td>
                                      </tr>
                                    ))
                                    }
                                  </tbody>:null)):
                                <tbody className="ant-table-tbody">
                                  <tr className="ant-table-row ant-table-row-level-0">
                                    <td className="ant-table-cell tname th-invoice-rec th-font-weight">
                                      <span className="type ellipse ellipse-inline">--</span>
                                    </td>
                                    <td className="ant-table-cell tname th-invoice-inv">
                                      <span className="type ellipse ellipse-inline">--</span>
                                    </td>
                                    <td className="ant-table-cell tname th-invoice-com">
                                      <span className="type ellipse ellipse-inline">--</span>
                                    </td>
                                  </tr>
                                </tbody>
                              }
                              {!_.isEmpty(invoiceReconciliationReport) && !_.isEmpty(invoiceReconciliationReport.franchise)?
                                <tfoot className="ant-table-thead">
                                  <tr>
                                    <th className="ant-table-cell tname th-invoice-rec invoice_rec_total">Total</th>                                    
                                    <th className="ant-table-cell tname th-invoice-com invoice_rec_total">
                                        ${formatToCurrency(invoiceReconciliationReport.services.total_completed)}
                                    </th>
                                    <th className="ant-table-cell tname th-invoice-inv invoice_rec_total">
                                        ${formatToCurrency(invoiceReconciliationReport.services.total_invoiced)}
                                    </th>
                                    <th className="ant-table-cell tname th-invoice-inv invoice_rec_total">
                                        ${formatToCurrency(invoiceReconciliationReport.services.total_completed_not_invoiced)}
                                    </th>
                                  </tr>
                                </tfoot>:null}
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>:null}
                {searchValue.includes('discount')?
                  <div className="ant-table-wrapper table hscroll border-around inner-table my-20 inv">
                    <div className="ant-spin-nested-loading">
                      <div className="ant-table">
                        <div className="ant-table-container">
                          <div className="ant-table-content">
                            <table style={{tableLayout: 'auto'}}>
                              <colgroup></colgroup>
                              <thead className="ant-table-thead">
                                <tr>
                                  <th className="ant-table-cell tname th-invoice-rec">Discount</th>
                                  <th className="ant-table-cell tname invname th-invoice-inv">Jobs Completed ($)</th>
                                  <th className="ant-table-cell tname invname th-invoice-com">Jobs Completed & Invoiced ($)</th>
                                  <th className="ant-table-cell tname invname th-invoice-com">Jobs Completed but not Invoiced ($)</th>
                                </tr>
                              </thead>
                              {!_.isEmpty(invoiceReconciliationReport) && !_.isEmpty(invoiceReconciliationReport.franchise)?
                                invoiceReconciliationReport.discounts.discount_list.map((discount,i)=>(
                                  !_.isEmpty(discount.discounts) && !_.isEmpty(invoiceReconciliationReport.franchise)?<tbody key={i} className="ant-table-tbody">
                                    <tr className="ant-table-thead invoice_rec_services">
                                      <th colSpan="4" style={{textAlign:"left"}}>{discount.discount_name}</th>
                                    </tr>
                                    {discount.discounts.map((discountslist,i)=>(
                                      <tr key={i} className="ant-table-row ant-table-row-level-0">
                                        <td className="ant-table-cell tname th-invoice-rec inv-service-list th-font-weight">
                                          <span className="type ellipse ellipse-inline">{discountslist.name}</span>
                                        </td>                                        
                                        <td className="ant-table-cell tname th-invoice-com">
                                          <span className="type ellipse ellipse-inline">${formatToCurrency(discountslist.completed_discount)}</span>
                                        </td>
                                        <td className="ant-table-cell tname th-invoice-inv">
                                          <span className="type ellipse ellipse-inline">${formatToCurrency(discountslist.invoiced_discount)}</span>
                                        </td>
                                        <td className="ant-table-cell tname th-invoice-inv">
                                          <span className="type ellipse ellipse-inline">${formatToCurrency(discountslist.completed_not_invoiced)}</span>
                                        </td>
                                      </tr>
                                    ))
                                    }
                                  </tbody>:null)):
                                <tbody className="ant-table-tbody">
                                  <tr className="ant-table-row ant-table-row-level-0">
                                    <td className="ant-table-cell tname th-invoice-rec th-font-weight">
                                      <span className="type ellipse ellipse-inline">--</span>
                                    </td>
                                    <td className="ant-table-cell tname th-invoice-inv">
                                      <span className="type ellipse ellipse-inline">--</span>
                                    </td>
                                    <td className="ant-table-cell tname th-invoice-com">
                                      <span className="type ellipse ellipse-inline">--</span>
                                    </td>
                                  </tr>
                                </tbody>
                              }
                              {!_.isEmpty(invoiceReconciliationReport) && !_.isEmpty(invoiceReconciliationReport.franchise)?
                                <tfoot className="ant-table-thead">
                                  <tr>
                                    <th className="ant-table-cell tname th-invoice-rec invoice_rec_total">Total</th>
                                    <th className="ant-table-cell tname th-invoice-com invoice_rec_total">
                                        ${formatToCurrency(invoiceReconciliationReport.discounts.total_completed)}
                                    </th>
                                    <th className="ant-table-cell tname th-invoice-inv invoice_rec_total">
                                        ${formatToCurrency(invoiceReconciliationReport.discounts.total_invoiced)}
                                    </th>
                                    <th className="ant-table-cell tname th-invoice-inv invoice_rec_total">
                                        ${formatToCurrency(invoiceReconciliationReport.discounts.total_completed_not_invoiced)}
                                    </th>                                    
                                  </tr>
                                </tfoot>:null}
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>:null}
                {searchValue.includes('tax')?
                  <div className="ant-table-wrapper table hscroll border-around inner-table my-20 inv">
                    <div className="ant-spin-nested-loading">
                      <div className="ant-table">
                        <div className="ant-table-container">
                          <div className="ant-table-content">
                            <table style={{tableLayout: 'auto'}}>
                              <colgroup></colgroup>
                              <thead className="ant-table-thead">
                                <tr>
                                  <th className="ant-table-cell tname th-invoice-rec">Tax</th>
                                  <th className="ant-table-cell tname invname th-invoice-inv">Jobs Completed ($)</th>
                                  <th className="ant-table-cell tname invname th-invoice-com">Jobs Completed & Invoiced ($)</th>
                                  <th className="ant-table-cell tname invname th-invoice-com">Jobs Completed but not Invoiced ($)</th>
                                </tr>
                              </thead>
                              {!_.isEmpty(invoiceReconciliationReport) && !_.isEmpty(invoiceReconciliationReport.franchise)?
                                invoiceReconciliationReport.sales_tax.tax_list.map((tax,i)=>(
                                  <tbody key={i} className="ant-table-tbody">
                                    <tr className="ant-table-row ant-table-row-level-0">
                                      <td className="ant-table-cell tname th-invoice-rec th-font-weight">
                                        <span className="type ellipse ellipse-inline">{tax.name}</span>
                                      </td>                                      
                                      <td className="ant-table-cell tname th-invoice-com">
                                        <span className="type ellipse ellipse-inline">N/A</span>
                                      </td>
                                      <td className="ant-table-cell tname th-invoice-inv">
                                        <span className="type ellipse ellipse-inline">${formatToCurrency(tax.invoiced_tax)}</span>
                                      </td>
                                      <td className="ant-table-cell tname th-invoice-com">
                                        <span className="type ellipse ellipse-inline">N/A</span>
                                      </td>
                                    </tr>
                                  </tbody>
                                )):
                                <tbody className="ant-table-tbody">
                                  <tr className="ant-table-row ant-table-row-level-0">
                                    <td className="ant-table-cell tname th-invoice-rec th-font-weight">
                                      <span className="type ellipse ellipse-inline">--</span>
                                    </td>
                                    <td className="ant-table-cell tname th-invoice-inv">
                                      <span className="type ellipse ellipse-inline">--</span>
                                    </td>
                                    <td className="ant-table-cell tname th-invoice-com">
                                      <span className="type ellipse ellipse-inline">--</span>
                                    </td>
                                  </tr>
                                </tbody>
                              }
                              {!_.isEmpty(invoiceReconciliationReport) && !_.isEmpty(invoiceReconciliationReport.franchise)?
                                <tfoot className="ant-table-thead">
                                  <tr>
                                    <th className="ant-table-cell tname th-invoice-rec invoice_rec_total">Total</th>
                                    <th className="ant-table-cell tname th-invoice-com invoice_rec_total">
                                       N/A
                                    </th>
                                    <th className="ant-table-cell tname th-invoice-inv invoice_rec_total">
                                        ${formatToCurrency(invoiceReconciliationReport.sales_tax.total_invoiced)}
                                    </th>
                                    <th className="ant-table-cell tname th-invoice-com invoice_rec_total">
                                       N/A
                                    </th>
                                  </tr>
                                </tfoot>:null}
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>:null}
              </div>
            </div>
          </div>
        </React.Fragment>
      }

      case "commercial_sales_report": {
        let { commercialReports, commercial_sales_report_pagination } = this.state;
        return (
          <React.Fragment>
            <Table
              rowKey={(record) => record.id}
              dataSource={commercialReports}
              columns={DataTable.CommercialSalesReports(this)}
              className="table hscroll border-around inner-table-second"
              pagination={commercial_sales_report_pagination}
              onChange={this.onCommercialSalesHandleChange}
            />

            <ul className="pagination_page_size">
              <li>
                <span>Show:</span>
              </li>
              <li>
                <span
                  onClick={() => {
                    this.setCommercialSalesPageLimit("15");
                  }}
                  className={active_pagination === "15" ? "active" : ""}
                >
                      15
                </span>
              </li>
              <li>
                <span
                  className={active_pagination === "30" ? "active" : ""}
                  onClick={() => {
                    this.setCommercialSalesPageLimit("30");
                  }}
                >
                      30
                </span>
              </li>
              <li>
                <span
                  className={active_pagination === "60" ? "active" : ""}
                  onClick={() => {
                    this.setCommercialSalesPageLimit("60");
                  }}
                >
                      60
                </span>
              </li>
            </ul>
          </React.Fragment>
        );
      }

      case "customer_price_increase_report": {
        let { customerPriceIncreaseReport, selectedRowKeysUpdate, customer_price_increase_report_pagination } = this.state;
        
        return (
          <React.Fragment>
           <div className="price-increase-rpt-custom_scroll"> 
            <Table
              rowKey={(record) => record.id}
              dataSource={customerPriceIncreaseReport}
              pagination={customer_price_increase_report_pagination}
              onChange={this.onPriceIncreaseReportHandleChange}
              rowSelection={{
                type: "checkbox",
                selectedRowKeys: selectedRowKeysUpdate,
                onSelectAll: () => this.handleSelectAll(),
                onChange: this.onSelectedRowKeysUpdateChange,
                columnTitle: () => this.renderHeaderCheckbox(this.state.is_select_all_raised_price_increase)              
              }}
              columns={DataTable.CustomerPriceIncreaseReport(this)}
              className="table hscroll"
            />
            </div>
            {this.state.franchiseFilters.field_office_id !== undefined || this.state.franchiseFilters.field_office_uuid !== undefined?
              this.state.franchiseFilters.field_office_id !== 'all' || this.state.franchiseFilters.field_office_uuid !== 'all'?
                <ul className="pagination_page_size" style={{marginTop:'auto'}}>
                  <li>
                    <span>Show:</span>
                  </li>
                  <li>
                    <span
                      onClick={() => {
                        this.setPriceIncreaseUserPageLimit("15");
                      }}
                      className={active_pagination === "15" ? "active" : ""}
                    >
                        15
                    </span>
                  </li>
                  <li>
                    <span
                      className={active_pagination === "30" ? "active" : ""}
                      onClick={() => {
                        this.setPriceIncreaseUserPageLimit("30");
                      }}
                    >
                        30
                    </span>
                  </li>
                  <li>
                    <span
                      className={active_pagination === "60" ? "active" : ""}
                      onClick={() => {
                        this.setPriceIncreaseUserPageLimit("60");
                      }}
                    >
                        60
                    </span>
                  </li>
                </ul>
              :<></>
              :<></>
            }
          </React.Fragment>
        );
      }

    case "customer-cancelation-report": {
      const { cancellationReport,cancellation_report_pagination,isShowPaginationFooter } = this.state;
      // const {is_disable_franchise} = this.getLoggedInUserRole();

      return <React.Fragment>
        <Table 
          rowKey={(record) => record.id}
          dataSource={cancellationReport}
          // columns={is_disable_franchise ? DataTable.CancellationReportWithoutFranchise(this) : DataTable.CancellationReport(this)}
          columns={DataTable.CancellationReport(this)}
          className="table hscroll"
          pagination={cancellation_report_pagination}
          onChange={this.onCancellationReportHandleChange}
        />
        { isShowPaginationFooter &&
          <ul className="pagination_page_size">
            <li>
              <span>Show:</span>
            </li>
            <li>
              <span
                onClick={() => { this.setCancellationReportPageLimit('15') }}
                className={active_pagination === '15' ? 'active' : ''}
              >15</span>
            </li>
            <li>
              <span
                className={active_pagination === '30' ? 'active' : ''}
                onClick={() => { this.setCancellationReportPageLimit('30') }}>30</span>
            </li>
            <li>
              <span
                className={active_pagination === '60' ? 'active' : ''}
                onClick={() => { this.setCancellationReportPageLimit('60') }}>60</span>
            </li>
          </ul>
        }
      </React.Fragment>
    }

    case "royalty-report": {
      let {royaltyReport, filters,loaderExport} = this.state;

        return <React.Fragment>
          <div className="row" style={{justifyContent:"space-between"}}>
            <h1>Royalty Report</h1>
            <button
              className="btn btn-warning"
              style={{"alignSelf": "baseline", "margin": "0px 10px"}}
              onClick={() => {
                this.setState({loaderExport: true});
                this.props.getRoyaltyReportCSV(filters);
              }}
              disabled={loaderExport}
            >
            {loaderExport ?"Exporting...":"Export"}
            </button>
          </div>
          <Table
            rowKey={(record) => record.id}
            className="table hscroll"
            rowClassName={(record, index) =>
              record.is_main ? 'main-row' : ''
            }
            dataSource={royaltyReport}
            pagination={false}
            columns={DataTable.RoyaltyReportDetails(this)}
            onChange={this.onRoyaltyHandleChange}
          /> 
        </React.Fragment>
      }

    case "lead_signup_report": {
      const { show_warning, stage,loaderExport } = this.state;

      return <React.Fragment>
        <div className="row" style={{justifyContent:"space-between"}}>
          <h1>Lead & Sign Up Report</h1>
          <button
            className="btn btn-warning"
            style={{"alignSelf": "baseline", "margin": "0px 10px"}}
            onClick={() => { this.onLeadSignupExport()}}
            disabled={loaderExport}
          >
          {loaderExport ?"Exporting...":"Export"}
          </button>
        </div>
        {
          show_warning ? 
            <div className="row" style={{
              backgroundColor: "#fff5cc",
              border: "1px solid #e6b800",
              color: "#b38f00",
              marginBottom: "15px",
              padding: "10px",
              borderRadius: "5px",
              display: "flex",
              justifyContent: "flex-end"
            }}>
              <AlertTriangle color="#e6b800" size="15" ></AlertTriangle>
              <span style={{display: "flex", marginLeft: "10px"}}>
                  When opening the file in Excel remember to set the data format of the 'zip code' column as category 'Special' and type 'ZIP Code', to show the leading zeros.
              </span>
            </div> : null
        }

        {      
          this.renderLeadSignupTable()
        }

        {
          stage !== '' && 
          <ul className="pagination_page_size">
            <li>
              <span>Show:</span>
            </li>
            <li>
              <span
                onClick={() => {
                  this.setLeadSignupReportPageLimit("15");
                }}
                className={active_pagination === "15" ? "active" : ""}
              >
                  15
              </span>
            </li>
            <li>
              <span
                className={active_pagination === "30" ? "active" : ""}
                onClick={() => {
                  this.setLeadSignupReportPageLimit("30");
                }}
              >
                  30
              </span>
            </li>
            <li>
              <span
                className={active_pagination === "60" ? "active" : ""}
                onClick={() => {
                  this.setLeadSignupReportPageLimit("60");
                }}
              >
                  60
              </span>
            </li>
          </ul>
        }
      </React.Fragment>
    }

      case 'coupon_report': {
        const {couponReport, filters,coupon_report_pagination,isShowPaginationFooter} = this.state;

        return <React.Fragment>
          {/* <div className="row" style={{justifyContent:"space-between"}}>
            <h1>Coupon Code Report</h1>
            <button
              className="btn btn-warning"
              style={{"alignSelf": "baseline", "margin": "0px 10px"}}
              onClick={() => {this.props.getCouponCodeReportCSV(filters)}}
            >
              Export
            </button>
          </div> */}
          <Table
            rowKey={(record) => record.id}
            className="table hscroll"
            dataSource={couponReport}
            pagination={coupon_report_pagination}
            columns={DataTable.CouponReportDetails(this)}
            onChange={this.onCouponReportHandleChange}
          /> 
          { isShowPaginationFooter &&
            <ul className="pagination_page_size">
              <li>
                <span>Show:</span>
              </li>
              <li>
                <span
                  onClick={() => { this.setCouponReportPageLimit('15') }}
                  className={active_pagination === '15' ? 'active' : ''}
                >15</span>
              </li>
              <li>
                <span
                  className={active_pagination === '30' ? 'active' : ''}
                  onClick={() => { this.setCouponReportPageLimit('30') }}>30</span>
              </li>
              <li>
                <span
                  className={active_pagination === '60' ? 'active' : ''}
                  onClick={() => { this.setCouponReportPageLimit('60') }}>60</span>
              </li>
            </ul>
          } 
        </React.Fragment>
      }

      default: {
        return this.props.history.push('/reports')
      }
    }
  }

  goToAllReports = () => {
    if(this.state.reportdetails){
      this.setState({
        reportdetails: false
      })
      this.props.getCommercialSalesReports({
        ...this.state.franchiseFilters
      })
    } else {
      this.props.history.push('/reports')
    }

  }

  resetFilters = () => {
    window.location.reload()
    this.setState({
      franchiseFilters: {}
    })
  }

  onSelectedRowKeysUpdateChange = (selectedRowKeysUpdate) => {
      this.setState({ selectedRowKeysUpdate });
  };

  handleSelectAll = () => {

    if(!this.state.is_select_all_raised_price_increase){
      let keys =  this.state.customerPriceIncreaseReport.map(row => row.id);
      this.setState({
        is_select_all_raised_price_increase: true,
        selectedRowKeysUpdate: keys

      });
    }else{
      this.setState({
        is_select_all_raised_price_increase: false,
        selectedRowKeysUpdate: []

      });
    }
  }

  renderHeaderCheckbox = (is_all_selected) => {
    return <Checkbox
      checked={is_all_selected}
      onChange={() => this.handleSelectAll()}
    />
  }
  
  resetSelectedRowKeysUpdate = () => {
    const previous_selected_customers_count = this.state.selectedRowKeysUpdate.length;
    this.setState({ previous_selected_customers_count: previous_selected_customers_count,is_select_all_raised_price_increase:false, selectedRowKeysUpdate: [] });
  }
  loadtoprightbar = (id) => {
    switch(id)
    {
      case 'customer_statement': {
        return <React.Fragment><div className="right_side">
          <div className="form-group flex ai-center w-100 flex-end fltr-txt">
            <button className="btn btn-warning" onClick={() => {this.getPdfReport(id)}}>Print</button>
            <button className="btn btn-warning" onClick={() => {this.getPdfReport(id)}}>Download</button>
          </div>
        </div>
        </React.Fragment>
      }

      case 'daily_log_report': {
        const { franchiseFilters } = this.state
        return <React.Fragment>
          <div className="form-group flex ai-center w-100 flex-end fltr-txt">
            <div className="fitem fitem-rinner licon mb-0">
              <div className="fitem-ricon">
                <i className="las la-search"></i>
              </div>
              <input
                type="text"
                placeholder="Search Franchise"
                className="form-control flex-1" 
                onChange={(e) => {
                  this.setState({
                    franchiseFilters: {
                      ...franchiseFilters,
                      search: e.target.value,
                      dailyReports:[]
                    }
                  })
                  this.props.getDailyLogReports({
                    ...franchiseFilters,
                    search: e.target.value
                  })
                }}
              />
            </div>
            <div className="fitem fitem-rinner licon mb-0">
              <Select
                className="sort_by swhite sort-by-border"
                showSearch
                showArrow={true}
                defaultValue='Franchise (A - Z)'
                suffixIcon={<i className="las la-angle-down"></i>}
                onChange={(e) => {
                  this.setState({
                    franchiseFilters: {
                      ...franchiseFilters,
                      ordering: e,
                    },
                    loader: true,
                    dailyReports:[]
                  })
                  this.props.getDailyLogReports({
                    ...franchiseFilters,
                    ordering: e
                  })
                }}
              >
                <Option value='user__serviceorder__field_office__name'>{`Franchise (A - Z)`}</Option>
                <Option value='-user__serviceorder__field_office__name'>{`Franchise (Z - A)`}</Option>

              </Select>
            </div>                  
            {this.state.reportdetails ?  <div className="fitem fitem-rinner licon mb-0"><button className="btn btn-warning" onClick={() => {this.getPdfReport(id)}}>Export</button></div> : ''}                
          </div>
        </React.Fragment>
      }

      case 'in_territory_revenue_reports': {
        return (
          <React.Fragment>
            <div className="form-group flex ai-center w-100 flex-end fltr-txt">
              <button className="btn btn-warning" onClick={() => this.getPdfReport(id)}>Export</button>
            </div>
          </React.Fragment>
        );
      }

      case 'customer_complaints_report': {
        const { franchiseFilters } = this.state
        return (
          <React.Fragment>
            <div className="form-group flex ai-center w-100 flex-end fltr-txt">
              <div className="fitem fitem-rinner licon mb-0">
                <div className="fitem-ricon">
                  <i className="las la-search"></i>
                </div>
                <input
                  type="text"
                  placeholder="Search Franchise"
                  className="form-control flex-1"
                  onChange={(e) => {
                    this.setState({
                      franchiseFilters: {
                        ...franchiseFilters,
                        search: e.target.value,
                      },
                      customerComplaintsReport:[]
                    });
                    this.props.getCustomerComplaintsReport({
                      ...franchiseFilters,
                      search: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="fitem fitem-rinner licon mb-0">
                <Select
                  className="sort_by swhite sort-by-border"
                  showSearch
                  showArrow={true}
                  defaultValue="Franchise (A - Z)"
                  suffixIcon={<i className="las la-angle-down"></i>}
                  onChange={(e) => {
                    this.setState({
                      franchiseFilters: {
                        ...franchiseFilters,
                        ordering: e,
                      },
                      loader: true,
                      customerComplaintsReport:[]
                    });
                    this.props.getCustomerComplaintsReport({
                      ...franchiseFilters,
                      ordering: e,
                    });
                  }}
                >
                  <Option value="name">{`Franchise (A - Z)`}</Option>
                  <Option value="-name">{`Franchise (Z - A)`}</Option>
                </Select>
              </div>
              {this.state.reportdetails ? (
                <div className="fitem fitem-rinner licon mb-0"><button className="btn btn-warning" onClick={() => {this.getPdfReport(id)}}>Export</button></div>
              ) : (
                ""
              )}
            </div>
          </React.Fragment>
        );
      }

      case 'invoice_revenue_report': {
        const { franchiseFilters,invoiceReconciliationReport } = this.state
        let data = [];
        data.push({franchise: invoiceReconciliationReport.franchise?invoiceReconciliationReport.franchise.charAt(0).toUpperCase() + invoiceReconciliationReport.franchise.slice(1):"", timeperiod: invoiceReconciliationReport.time_period?`${moment(invoiceReconciliationReport.time_period.split("#")[0]).format('ll')} - ${moment(invoiceReconciliationReport.time_period.split("#")[1]).format('ll')}`:"--", totaljobscompleted: "$"+String(formatToCurrency(invoiceReconciliationReport.total_jobs_completed_value)), totalinvoiced: "with tax: "+ "$"+String(formatToCurrency(invoiceReconciliationReport.total_invoiced)),totaljobscompletednotinvoiced: !_.isEmpty(invoiceReconciliationReport) && !_.isEmpty(invoiceReconciliationReport.franchise) ?"$"+String(formatToCurrency((invoiceReconciliationReport.total_jobs_completed_value - (invoiceReconciliationReport.total_invoiced -invoiceReconciliationReport.sales_tax.total_invoiced)))):"$"+String(formatToCurrency(0.00))});
        data.push({franchise:"", timeperiod: "",totaljobscompleted: "", totalinvoiced: !_.isEmpty(invoiceReconciliationReport) && !_.isEmpty(invoiceReconciliationReport.franchise) ?"without tax: "+ String("$"+String(invoiceReconciliationReport.total_invoiced - invoiceReconciliationReport.sales_tax.total_invoiced)):"without tax: "+ String("$"+String(invoiceReconciliationReport.total_invoiced)), totaljobscompletednotinvoiced: ""});
        data.push({franchise:"", timeperiod: "",totaljobscompleted: "", totalinvoiced: "", totaljobscompletednotinvoiced: ""});
        data.push({franchise:"Products", timeperiod: "",totaljobscompleted: "Jobs Completed ($)", totalinvoiced: "Jobs Completed & Invoiced ($)", totaljobscompletednotinvoiced: "Jobs Completed but not Invoiced ($)"});
        !_.isEmpty(invoiceReconciliationReport)?invoiceReconciliationReport.products.product_list.map(function(products){
          data.push({franchise:products.name?products.name.charAt(0).toUpperCase() + products.name.slice(1):"", timeperiod: "",totaljobscompleted: "$"+String(products.completed_price), totalinvoiced:"$"+String(products.invoiced_price),totaljobscompletednotinvoiced: "$"+String(products.completed_not_invoiced) })
        }):data.push({franchise:"", timeperiod: "",  totaljobscompleted: "",totalinvoiced: "",totaljobscompletednotinvoiced: ""})
        data.push({franchise:"Total", timeperiod:"" ,totaljobscompleted: !_.isEmpty(invoiceReconciliationReport) && invoiceReconciliationReport.products.total_completed?"$"+String(invoiceReconciliationReport.products.total_completed):"$"+String(0), totalinvoiced:!_.isEmpty(invoiceReconciliationReport) && invoiceReconciliationReport.products.total_invoiced?"$"+String(invoiceReconciliationReport.products.total_invoiced):"$"+String(0),totaljobscompletednotinvoiced: !_.isEmpty(invoiceReconciliationReport) && invoiceReconciliationReport.products.total_completed_not_invoiced?"$"+String(invoiceReconciliationReport.products.total_completed_not_invoiced):"$"+String(0)})
        data.push({franchise:"", timeperiod: "",totaljobscompleted: "", totalinvoiced: "",totaljobscompletednotinvoiced:""})
        data.push({franchise:"Services", timeperiod: "",totaljobscompleted: "Jobs Completed ($)", totalinvoiced: "Jobs Completed & Invoiced ($)", totaljobscompletednotinvoiced: "Jobs Completed but not Invoiced ($)"});
        !_.isEmpty(invoiceReconciliationReport)?invoiceReconciliationReport.services.service_list.map(function (service) {
          data.push({franchise:service.service_name?service.service_name.charAt(0).toUpperCase() + service.service_name.slice(1):"", timeperiod: "", totaljobscompleted: "", totalinvoiced: "",totaljobscompletednotinvoiced:""})
          !_.isEmpty(service.services)?  service.services.map(function (servicelist) {
            data.push({franchise:servicelist.name?servicelist.name.charAt(0).toUpperCase() + servicelist.name.slice(1):"", timeperiod: "",totaljobscompleted: "$"+String(servicelist.completed_price), totalinvoiced:"$"+String(servicelist.invoiced_price),totaljobscompletednotinvoiced: "$"+String(servicelist.completed_not_invoiced) })
          }):data.push({franchise:"", timeperiod: "", totaljobscompleted: "", totalinvoiced: "",totaljobscompletednotinvoiced: ""})
        }):data.push({franchise:"", timeperiod: "", totaljobscompleted: "", totalinvoiced: "",totaljobscompletednotinvoiced: ""})
        data.push({franchise:"Total", timeperiod:"",totaljobscompleted: !_.isEmpty(invoiceReconciliationReport) && invoiceReconciliationReport.services.total_completed?"$"+String(invoiceReconciliationReport.services.total_completed):"$"+String(0) , totalinvoiced:!_.isEmpty(invoiceReconciliationReport) && invoiceReconciliationReport.services.total_invoiced?"$"+String(invoiceReconciliationReport.services.total_invoiced):"$"+String(0), totaljobscompletednotinvoiced: !_.isEmpty(invoiceReconciliationReport) && invoiceReconciliationReport.services.total_completed_not_invoiced?"$"+String(invoiceReconciliationReport.services.total_completed_not_invoiced):"$"+String(0)})
        data.push({franchise:"", timeperiod: "",  totaljobscompleted: "", totalinvoiced: "",totaljobscompletednotinvoiced: ""})
        data.push({franchise:"Discount", timeperiod: "",totaljobscompleted: "Jobs Completed ($)", totalinvoiced: "Jobs Completed & Invoiced ($)", totaljobscompletednotinvoiced: "Jobs Completed but not Invoiced ($)"});
        !_.isEmpty(invoiceReconciliationReport)?invoiceReconciliationReport.discounts.discount_list.map(function (discount) {
          data.push({franchise:discount.discount_name?discount.discount_name.charAt(0).toUpperCase() + discount.discount_name.slice(1):"", timeperiod: "",totaljobscompleted: "", totalinvoiced: "",totaljobscompletednotinvoiced: "" })
          !_.isEmpty(invoiceReconciliationReport)?discount.discounts.map(function (discountlist) {
            data.push({franchise:discountlist.name?discountlist.name.charAt(0).toUpperCase() + discountlist.name.slice(1):"", timeperiod: "",totaljobscompleted: "$"+String(discountlist.completed_discount), totalinvoiced: "$"+String(discountlist.invoiced_discount), totaljobscompletednotinvoiced: "$"+String(discountlist.completed_not_invoiced)})
          }):data.push({franchise:"", timeperiod: "",  totaljobscompleted: "", totalinvoiced: "",totaljobscompletednotinvoiced: ""})
        }):data.push({franchise:"", timeperiod: "",  totaljobscompleted: "", totalinvoiced: "",totaljobscompletednotinvoiced: ""})
        data.push({franchise:"Total", timeperiod:"", totaljobscompleted: !_.isEmpty(invoiceReconciliationReport) && invoiceReconciliationReport.discounts.total_completed?"$"+String(invoiceReconciliationReport.discounts.total_completed):"$"+String(0) , totalinvoiced:!_.isEmpty(invoiceReconciliationReport) && invoiceReconciliationReport.discounts.total_invoiced?"$"+String(invoiceReconciliationReport.discounts.total_invoiced):"$"+String(0), totaljobscompletednotinvoiced: !_.isEmpty(invoiceReconciliationReport) && invoiceReconciliationReport.discounts.total_completed_not_invoiced?"$"+String(invoiceReconciliationReport.discounts.total_completed_not_invoiced):"$"+String(0)})
        data.push({franchise:"", timeperiod: "",  totaljobscompleted: "", totalinvoiced: "",totaljobscompletednotinvoiced: ""})
        data.push({franchise:"Tax", timeperiod: "",totaljobscompleted: "Jobs Completed ($)", totalinvoiced: "Jobs Completed & Invoiced ($)", totaljobscompletednotinvoiced: "Jobs Completed but not Invoiced ($)"});
        !_.isEmpty(invoiceReconciliationReport)?invoiceReconciliationReport.sales_tax.tax_list.map(function(tax){
          data.push({franchise:tax.name?tax.name.charAt(0).toUpperCase() + tax.name.slice(1):"", timeperiod: "", totaljobscompleted: 'N/A', totalinvoiced:"$"+String(tax.invoiced_tax),totaljobscompletednotinvoiced: 'N/A'})
        }):data.push({franchise:"", timeperiod: "",  totaljobscompleted: "", totalinvoiced: "",totaljobscompletednotinvoiced: ""})
        data.push({franchise:"Total", timeperiod: "", totaljobscompleted: 'N/A',totalinvoiced:!_.isEmpty(invoiceReconciliationReport) && invoiceReconciliationReport.sales_tax.total_invoiced?"$"+String(invoiceReconciliationReport.sales_tax.total_invoiced):"$"+String(0), totaljobscompletednotinvoiced: 'N/A'})
        data.push({franchise:"", timeperiod: "",  totaljobscompleted: "", totalinvoiced: "",totaljobscompletednotinvoiced: ""})
        //data.push({franchise:"Total", timeperiod: "", totaljobscompleted: invoiceReconciliationReport.total_jobs_completed_value, totalinvoiced:invoiceReconciliationReport.total_invoiced, totaljobscompletednotinvoiced: (invoiceReconciliationReport.total_jobs_completed_value - invoiceReconciliationReport.total_invoiced)})
        
        return (
          <React.Fragment>
            <div className="form-group flex ai-center w-100 flex-end fltr-txt">
             {/*
              <div className="fitem fitem-rinner licon mb-0">
                <div className="fitem-ricon">
                  <i className="las la-search"></i>
                </div>
                <input
                  type="text"
                  placeholder="Search Product, Service, or Discount "
                  className="form-control flex-1"
                  onChange={(e) => {
                    this.setState({
                      franchiseFilters: {
                        ...franchiseFilters,
                        search: e.target.value,
                      },
                    });
                  }}
                />
              </div>
            */}
              <div className="fitem fitem-rinner licon mb-0">
                <CSVLink
                  headers={this.state.headers}
                  data={data}                  
                  filename="job_completed_to_invoiced_reconciliation_report.csv"
                >
                { this.state.franchiseFilters.field_office_id !== undefined && this.state.franchiseFilters.field_office_id !== '' && this.state.franchiseFilters.field_office_id !== 'all'? <button className="btn btn-warning">Export</button>: <></> }
                </CSVLink>
              </div>
            </div>
          </React.Fragment>
        );
      }

      case 'commercial_sales_report': {
        const { franchiseFilters } = this.state
        return (
          <React.Fragment>
            {this.state.reportdetails ? <React.Fragment><div className="form-group flex ai-center w-100 flex-end fltr-txt">
              <div className="fitem fitem-rinner licon mb-0">
                <div className="fitem-ricon">
                  <i className="las la-search"></i>
                </div>
                <input
                  type="text"
                  placeholder="Search Individual BDO"
                  className="form-control flex-1"
                  onChange={(e) => {
                    this.setState({
                      franchiseFilters: {
                        ...franchiseFilters,
                        search: e.target.value,
                        commercialReportDetails:[]
                      },
                    });
                    this.props.getCommercialSalesReportsDetails({
                      id: franchiseFilters.id,
                      searching: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="fitem fitem-rinner licon mb-0">
                <Select
                  className="sort_by swhite sort-by-border"
                  showSearch
                  showArrow={true}
                  value={this.state.reportdetails ? `BDO (A - Z)` : `BDO (A - Z)`}
                  suffixIcon={<i className="las la-angle-down"></i>}
                  onChange={(e) => {
                    this.setState({
                      commercialReportDetails:[],
                      franchiseFilters: {
                        ...franchiseFilters,
                        ordering: e,
                      },
                      loader: true,
                    });
                    this.props.getCommercialSalesReportsDetails({
                      id: franchiseFilters.id,
                      ordering: e,
                    });
                  }}
                >
                  <Option value="business_development_officer">{`BDO (A - Z)`}</Option>
                  <Option value="-business_development_officer">{`BDO (Z - A)`}</Option>
                </Select>
              </div>
            </div> </React.Fragment> : <div className="form-group flex ai-center w-100 flex-end fltr-txt">
              <div className="fitem fitem-rinner licon mb-0">
                <div className="fitem-ricon">
                  <i className="las la-search"></i>
                </div>
                <input
                  type="text"
                  placeholder="Search Individual BDO"
                  className="form-control flex-1"
                  onChange={(e) => {
                    this.setState({
                      franchiseFilters: {
                        ...franchiseFilters,
                        search: e.target.value,
                        commercialReports: []
                      },
                    });
                    this.props.getCommercialSalesReports({
                      ...franchiseFilters,
                      search: e.target.value,
                    });

                  }}
                />
              </div>
              <div className="fitem fitem-rinner licon mb-0">
                <Select
                  className="sort_by swhite sort-by-border"
                  showSearch
                  showArrow={true}
                  // defaultValue="Franchise (A - Z)"
                  value={this.state.commercial_sales_report_ordering}
                  suffixIcon={<i className="las la-angle-down"></i>}
                  onChange={(e) => {
                    this.setState({
                      commercial_sales_report_ordering : e
                    })
                    this.props.getCommercialSalesReports({
                      ...franchiseFilters,
                      ordering: e,
                    });
                    this.setState({
                      commercialReports: [],
                      franchiseFilters: {
                        ...franchiseFilters,
                        ordering: e,
                      },
                      loader: true,
                    });
                  }}
                >
                  <Option value="name">{`Franchise (A - Z)`}</Option>
                  <Option value="-name">{`Franchise (Z - A)`}</Option>
                </Select>
              </div>
            </div>
            }
          </React.Fragment>
        );
      }

      case "customer_price_increase_report": {
        return (
          <React.Fragment>
            <div className="form-group flex ai-center w-100 flex-end fltr-txt">
              <button
                style={{marginRight: '25%'}}                
                className={`btn ${this.state.selectedRowKeysUpdate.length > 0 ?  "btn-warning": "btn-disabled"}`}
                onClick={() => {
                  this.BatchUpdateToggle(true);
                }}
                disabled={
                  this.state.selectedRowKeysUpdate.length > 0 ? false : true
                }
              >
                Batch Update Selected Customers
              </button>
            </div>
          </React.Fragment>
        );
      }

      case 'customer-cancelation-report': {
        const { franchiseFilters ,loaderExport} = this.state
        return (
          <React.Fragment>
            <div className="fitem fitem-rinner licon mb-0">
              <button className="btn btn-warning" onClick={() => this.getReport(id)}
                disabled={loaderExport}
              >
                {loaderExport ?"Exporting...":"Export"}
              </button>
            </div>
          </React.Fragment>
        );
      }

      default: return;
    }
  }

  loadTopNav = (id) => {
    switch(id) 
    {
        case 'commercial_sales_report': {
          return this.state.reportdetails ? <li onClick={() => this.goToAllReports()}>
            <span className="pointer"><i className="las la-angle-left"></i> Back to Commercial Sales Report</span>
          </li> :  <li onClick={() => this.goToAllReports()}>
            <span className="pointer"><i className="las la-angle-left"></i> Back to All Reports</span>
          </li>
        }

        default:  {
          return <li onClick={() => this.goToAllReports()}>
            <span className="pointer"><i className="las la-angle-left"></i> Back to All Reports</span>
          </li>
        }
    }
  }

  getReport = (id) => {
    const {filters,isShowPaginationFooter} = this.state;
    switch(id)
    {
      case 'customer-cancelation-report': {
        //export only if build report button is clicked
        if(isShowPaginationFooter){
          this.setState({loaderExport: true});
          this.props.getCancellationReportCSV({...filters});
        }
      break;
      }

      default: return;
    }
  }
  
  getPdfReport = (id) => {
    switch(id)
    {
      case 'customer_statement': {
        let searchquery = ''
        if(this.state.franchiseFilters){
          let keys=Object.keys(this.state.franchiseFilters)
          for(let i = 0; i< keys.length; i++){
            if(i === keys.length - 1){
              searchquery += `${keys[i]}=${this.state.franchiseFilters[keys[i]]}`
            } else {
              searchquery += `${keys[i]}=${this.state.franchiseFilters[keys[i]]}&`
            }
          }
        }
        this.props.getPdfReport({
          report_type: 'customer_invoice_report',
          is_export: 'false',
          searchquery: searchquery
        });
        break;
      }

      case 'daily_log_report': {
        if(this.state.franchiseFilters.franchise_id){
          let searchquery=`franchise_id=${this.state.franchiseFilters.franchise_id}&search=${this.state.franchiseFilters.search}&created_at__date=${this.state.franchiseFilters.created_at__date}`
          this.props.getPdfReport({
            report_type: 'customer_daily_log_report',
            is_export: 'false',
            searchquery: searchquery
          })
        }else{
          this.props.getPdfReport({
            report_type: 'customer_daily_log_report',
            is_export: 'false'
          })
        }
        break;
      }

      case 'in_territory_revenue_reports': {
        if(this.state.franchiseFilters.id){
          let searchquery=`field_office_id=${this.state.franchiseFilters.id}&u_type=${this.state.franchiseFilters.type.toLowerCase().replace(/ /g,"_")}`
          this.props.getPdfReport({
            report_type: 'customer_territory_revenue_report',
            is_export: 'false',
            searchquery: searchquery
          })
        } else{
          this.props.getPdfReport({
            report_type: 'customer_territory_revenue_report',
            is_export: 'false'
          })
        }
        break;
      }

      case 'customer_complaints_report': {
        if(this.state.franchiseFilters.id){
          let searchquery=`id=${this.state.franchiseFilters.id}`
          this.props.getPdfReport({
            report_type: 'customer_complaint_report',
            is_export: 'false',
            searchquery: searchquery
          })
        } else{
          this.props.getPdfReport({
            report_type: 'customer_complaint_report',
            is_export: 'false'
          })
        }
        break;
      }

      default: return;
    }
  }

  render() {
    let { loader, title, id, search_value } = this.state;
    return (
      <div
        id="wrapper"

        className= { this.props.location.state.query.id === "invoice_revenue_report"?"invoice-rec-wrapper":"" }

      >
        <div className="content-area">
          
          {/* Header */}
          {
            this.props.location.state.query.id !== "royalty-report" && this.props.location.state.query.id !== "lead_signup_report" ? 
              <Header
                placeholder={"Search acc number, customer address or contact details"}
                search_value={search_value}
                onSearch={this.onSearch}
                onEnter={(e) => this.setState({search_value: '', loader: true}, () => this.onSearch(e))}
              /> : null
          }

          {/* Sidebar */}
          <Sidebar history={this.props.history} />
          
          {/* Main Container */}
          <div className="container">
            <div className="aside-area pt-0 account_module_wrapper">
              {this.loadSidebar(this.props.location.state.query.id)}
              <div className="main p-0">
                <div className="block-row pt-10">
                  <ul className="breadcrumb">
                    {this.loadTopNav(id)}
                  </ul>
                  <div className=" row acc-wrap p-0 mb-20" style={{justifyContent: "space-between", marginTop: "15px", padding: "15px"}}>
                    <div className="left_side align-items-center">
                      <h2 className="m-0 text-nowrap pr-10">{title}</h2>
                      {id === 'customer_statement' ? <button className="btn btn-warning btn-small ml-10" onClick={() => {this.goToCustomerAccount()}}>Go to Account</button> : ''}
                    </div>

                    {this.loadtoprightbar(id)}
                  </div>
                  <div className="report-table">
                    {this.state.reportdetails ? this.renderReportDetails(this.state.id) :this.renderTableData(this.props.location.state.query.id)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Drawer
          visible={this.state.is_Batch_Update_Selected_Customers}
          width={"400"}
          closable={false}
          className="drawer-wrapper create_ticket_drawer"
        >
          <BatchUpdateSelectedCustomers
            postCustomerPriceIncreaseReport={this.props.postCustomerPriceIncreaseReport}
            is_message_table={this.state.is_Batch_Update_Selected_Customers}
            BatchUpdateToggle={() => {
              this.BatchUpdateToggle();
            }}
            selectedRowKeysUpdate={this.state.selectedRowKeysUpdate}
            resetSelectedRowKeysUpdate = {this.resetSelectedRowKeysUpdate}
            selected_customers_count = {this.state.selectedRowKeysUpdate.length === 0? this.state.previous_selected_customers_count : this.state.selectedRowKeysUpdate.length}
          />
        </Drawer>
        
        {loader ? <Loader /> : ""}
      </div>
    );
  }
}

export default ReportList;
